import { ref as M, onBeforeUnmount as dn, unref as N, readonly as Wn, getCurrentInstance as Nt, onMounted as un, nextTick as Hn, watch as be, useId as et, mergeProps as z, openBlock as k, createElementBlock as C, createElementVNode as V, renderSlot as pe, createTextVNode as tt, toDisplayString as Y, resolveComponent as $t, resolveDirective as cn, withDirectives as at, createBlock as oe, resolveDynamicComponent as pn, withCtx as Ee, createCommentVNode as D, normalizeClass as ke, Transition as Yn, defineComponent as mn, computed as U, reactive as Lt, createVNode as he, Fragment as _t, vShow as fn } from "vue";
const bn = "https://cdn.sbx.neononepay.com/5.0/neonpay.js", Gn = "https://cdn.app.neononepay.com/5.0/neonpay.js", Zn = bn;
function qn(e) {
  return e === !0 ? bn : e === !1 ? Gn : Zn;
}
const Xn = "UNSUPPORTED_PAYMENT_METHOD";
let fe = null;
function Qn(e) {
  if (typeof window > "u")
    return Promise.reject(new Error("Neon Pay SDK requires a browser window."));
  if (window.NeonPay) return Promise.resolve(window.NeonPay);
  if (fe) return fe;
  const t = qn(e?.sandbox);
  return fe = new Promise((n, o) => {
    const r = document.querySelector(`script[data-neonpay-sdk="${t}"]`);
    if (r) {
      if (window.NeonPay) {
        n(window.NeonPay);
        return;
      }
      r.addEventListener(
        "load",
        () => {
          window.NeonPay ? n(window.NeonPay) : (fe = null, o(new Error("Neon Pay SDK loaded but did not register window.NeonPay")));
        },
        { once: !0 }
      ), r.addEventListener(
        "error",
        () => {
          fe = null, o(new Error(`Failed to load Neon Pay SDK from ${t}`));
        },
        { once: !0 }
      );
      return;
    }
    const l = document.createElement("script");
    l.src = t, l.async = !0, l.dataset.neonpaySdk = t, l.addEventListener("load", () => {
      if (!window.NeonPay) {
        fe = null, o(new Error("Neon Pay SDK loaded but did not register window.NeonPay"));
        return;
      }
      n(window.NeonPay);
    }), l.addEventListener("error", () => {
      fe = null, o(new Error(`Failed to load Neon Pay SDK from ${t}`));
    }), document.head.appendChild(l);
  }), fe;
}
function Jn(e, t) {
  return e ? (t === "ach" ? e.achMerchant : e.digitalWalletMerchant) ?? e : null;
}
const eo = {
  visa: "visa",
  mastercard: "mc",
  amex: "amex",
  "american express": "amex",
  discover: "disc",
  diners_club: "unknown",
  jcb: "unknown"
}, to = /* @__PURE__ */ new Set([
  "card",
  "cardNumber",
  "cardExpiration",
  "cardCvc"
]);
function gn(e) {
  const t = /^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:\s*[,/]\s*([\d.]+))?/.exec(e);
  return t ? {
    r: Number(t[1]),
    g: Number(t[2]),
    b: Number(t[3]),
    a: t[4] === void 0 ? 1 : Number(t[4])
  } : null;
}
function no(e) {
  let t = 0, n = 0, o = 0, r = 1;
  for (let l = e; l && r > 1e-3; l = l.parentElement) {
    const s = gn(window.getComputedStyle(l).backgroundColor);
    if (!s || s.a === 0) continue;
    const i = r * s.a;
    t += s.r * i, n += s.g * i, o += s.b * i, r -= i;
  }
  return t += 255 * r, n += 255 * r, o += 255 * r, `rgb(${Math.round(t)}, ${Math.round(n)}, ${Math.round(o)})`;
}
function Et(e) {
  const t = gn(no(e));
  return t && (t.r * 0.299 + t.g * 0.587 + t.b * 0.114) / 255 < 0.5 ? "dark" : "light";
}
function zt(e) {
  const t = (n) => eo[n.toLowerCase()] ?? "unknown";
  if (typeof e == "string") return t(e);
  if (e && typeof e == "object" && "brand" in e) {
    const n = e.brand;
    if (typeof n == "string") return t(n);
  }
  return "unknown";
}
function oo(e) {
  const t = window.getComputedStyle(e);
  let n = t.color;
  try {
    const r = window.getComputedStyle(e, "::placeholder");
    r?.color && (n = r.color);
  } catch {
  }
  let o = "#dc2626";
  try {
    const r = document.createElement("span");
    r.style.cssText = "position:absolute;visibility:hidden;color:var(--app-invalid,#dc2626)", e.appendChild(r), o = window.getComputedStyle(r).color, e.removeChild(r);
  } catch {
  }
  return {
    base: {
      color: t.color,
      fontFamily: t.fontFamily,
      fontSize: t.fontSize,
      fontWeight: t.fontWeight,
      lineHeight: t.lineHeight,
      letterSpacing: t.letterSpacing
    },
    invalid: { color: o },
    "::placeholder": { color: n }
  };
}
function vn(e) {
  const t = e.fieldType ?? "card", n = to.has(t), o = M(!1), r = M(!1), l = M(!1), s = M(null), i = M("unknown");
  let a = null, d = null, u = null, c = null, p = null;
  const m = [];
  function b(_, x) {
    m.push({ event: _, handler: x }), d?.on(_, x);
  }
  function v(_) {
    const x = N(e.fieldOptions) ?? {};
    return n ? (c = Et(_), p === null && (p = _.style.colorScheme), _.style.colorScheme = "light", {
      style: e.fieldStyle ?? oo(_),
      hideBorders: !0,
      ...x
    }) : x;
  }
  function g() {
    const _ = e.container.value;
    return !_ || !n || c === null ? !1 : Et(_) !== c;
  }
  async function $() {
    if (u) return u;
    if (a && d) return;
    const _ = e.container.value;
    if (_)
      return u = (async () => {
        s.value = null;
        try {
          const x = await Qn({ sandbox: N(e.sandbox) });
          if (a || (a = N(e.gateway) ? new x(N(e.publicKey), N(e.merchantId), { gateway: !0 }) : new x(N(e.publicKey), N(e.merchantId)), l.value = await a.canMakePayments(), r.value = !0), !l.value) return;
          if (!d) {
            d = a.createField(t, v(_)), (t === "card" || t === "cardNumber") && d.on("cardbrand", (A) => {
              const K = zt(A);
              i.value = K, e.onBrandChange?.(K);
            });
            for (const A of m) d.on(A.event, A.handler);
            d.mount(_), o.value = !0;
          }
        } catch (x) {
          s.value = x instanceof Error ? x.message : "The card form didn't load. Refresh the page and try again.", r.value = !0;
        } finally {
          u = null;
        }
      })(), u;
  }
  async function S(_) {
    if (!a || !d)
      return { status: "decline", message: "The card form is still loading. Try again in a moment." };
    let x;
    try {
      const B = {
        reuse: !0,
        ...N(e.tokenData) ?? {},
        ..._ ?? {}
      };
      x = await a.createToken(d, B);
    } catch (B) {
      return B && typeof B == "object" && "address_zip" in B ? { status: "decline", field: "postalCode", message: "Enter a valid postal code." } : {
        status: "decline",
        message: B instanceof Error ? B.message : "We couldn't process that card. Try again."
      };
    }
    if (x.error || !x.token)
      return { status: "decline", message: x.error?.message ?? "We couldn't process that card. Try another card." };
    const A = x, K = A.number ?? A.last4 ?? (A.bin ? A.bin.slice(-4) : "••••"), W = A.method ? zt(A.method) : i.value;
    return { status: "success", token: x.token, brand: W, last4: K };
  }
  function O() {
    const _ = e.container.value;
    _?.id && d && d.unmountField?.(`#${_.id}`), _ && p !== null && (_.style.colorScheme = p), p = null, a = null, d = null, c = null, o.value = !1;
  }
  async function f() {
    O(), r.value = !1, l.value = !1, await $();
  }
  function y(_) {
    return d?.setPrice ? (d.setPrice(_), !0) : !1;
  }
  return dn(O), {
    ready: o,
    initialized: r,
    canMakePayment: l,
    error: s,
    lastBrand: i,
    init: $,
    createToken: S,
    unmount: O,
    remount: f,
    setPrice: y,
    on: b,
    colorSchemeChanged: g
  };
}
const ro = 400;
function Ot(e) {
  const t = e.replace(/\D/g, "");
  return /^4/.test(t) ? "visa" : /^3[47]/.test(t) ? "amex" : /^(5[1-5]|222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)/.test(t) ? "mc" : /^6(?:011|5)/.test(t) ? "disc" : "unknown";
}
function mt(e) {
  const t = e.replace(/\D/g, "");
  if (t.length < 12 || t.length > 19) return !1;
  let n = 0, o = !1;
  for (let r = t.length - 1; r >= 0; r--) {
    let l = t.charCodeAt(r) - 48;
    if (l < 0 || l > 9) return !1;
    o && (l *= 2, l > 9 && (l -= 9)), n += l, o = !o;
  }
  return n % 10 === 0;
}
function ft(e, t = /* @__PURE__ */ new Date()) {
  const n = /^(\d{2})\s*\/?\s*(\d{2})$/.exec(e.trim());
  if (!n) return !1;
  const o = Number(n[1]), r = 2e3 + Number(n[2]);
  if (o < 1 || o > 12) return !1;
  const l = new Date(Date.UTC(r, o, 0, 23, 59, 59, 999));
  return t <= l;
}
function bt(e, t) {
  const n = e.replace(/\D/g, "");
  return t === "amex" ? n.length === 4 : n.length === 3;
}
function gt(e) {
  const t = e.trim();
  return t.length >= 3 && t.length <= 10;
}
function ao(e) {
  const t = e.replace(/\D/g, "").slice(0, 19);
  return Ot(t) === "amex" ? [t.slice(0, 4), t.slice(4, 10), t.slice(10, 15)].filter(Boolean).join(" ") : t.match(/.{1,4}/g)?.join(" ") ?? "";
}
function io(e) {
  const t = e.replace(/\D/g, "").slice(0, 4);
  return t.length < 3 ? t : `${t.slice(0, 2)}/${t.slice(2)}`;
}
async function lo(e, t = {}) {
  const n = e.number.replace(/\D/g, ""), o = n.slice(-4), r = Ot(n);
  return await so(t.delayMs ?? ro), n === "4000000000000002" ? {
    status: "decline",
    message: "Your card was declined. Try another card."
  } : n === "4000000000000259" ? {
    status: "success",
    token: `mock-token-${r}-${o}-pending`,
    brand: r,
    last4: o
  } : {
    status: "success",
    token: `mock-token-${r}-${o}-success`,
    brand: r,
    last4: o
  };
}
function At(e) {
  switch (e) {
    case "visa":
      return "VISA";
    case "mc":
      return "MC";
    case "amex":
      return "AMEX";
    case "disc":
      return "DISC";
    default:
      return "CARD";
  }
}
function so(e) {
  return new Promise((t) => setTimeout(t, e));
}
function li(e) {
  if (!e || !/^\d{2}\/\d{2}$/.test(e)) return !1;
  const t = e.split("/");
  if (t.length !== 2) return !1;
  const n = parseInt(t[0], 10), o = 2e3 + parseInt(t[1], 10);
  return isNaN(n) || isNaN(o) || n < 1 || n > 12 ? !1 : Date.now() > Date.UTC(o, n, 0, 23, 59, 59, 999);
}
function ye(...e) {
  if (e) {
    let t = [];
    for (let n = 0; n < e.length; n++) {
      let o = e[n];
      if (!o) continue;
      let r = typeof o;
      if (r === "string" || r === "number") t.push(o);
      else if (r === "object") {
        let l = Array.isArray(o) ? [ye(...o)] : Object.entries(o).map(([s, i]) => i ? s : void 0);
        t = l.length ? t.concat(l.filter((s) => !!s)) : t;
      }
    }
    return t.join(" ").trim();
  }
}
function uo(e, t) {
  return e ? e.classList ? e.classList.contains(t) : new RegExp("(^| )" + t + "( |$)", "gi").test(e.className) : !1;
}
function co(e, t) {
  if (e && t) {
    let n = (o) => {
      uo(e, o) || (e.classList ? e.classList.add(o) : e.className += " " + o);
    };
    [t].flat().filter(Boolean).forEach((o) => o.split(" ").forEach(n));
  }
}
function vt(e, t) {
  if (e && t) {
    let n = (o) => {
      e.classList ? e.classList.remove(o) : e.className = e.className.replace(new RegExp("(^|\\b)" + o.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };
    [t].flat().filter(Boolean).forEach((o) => o.split(" ").forEach(n));
  }
}
function It(e) {
  return e ? Math.abs(e.scrollLeft) : 0;
}
function po(e, t) {
  return e instanceof HTMLElement ? e.offsetWidth : 0;
}
function mo(e) {
  if (e) {
    let t = e.parentNode;
    return t && t instanceof ShadowRoot && t.host && (t = t.host), t;
  }
  return null;
}
function fo(e) {
  return !!(e !== null && typeof e < "u" && e.nodeName && mo(e));
}
function Ye(e) {
  return typeof Element < "u" ? e instanceof Element : e !== null && typeof e == "object" && e.nodeType === 1 && typeof e.nodeName == "string";
}
function nt(e, t = {}) {
  if (Ye(e)) {
    let n = (o, r) => {
      var l, s;
      let i = (l = e?.$attrs) != null && l[o] ? [(s = e?.$attrs) == null ? void 0 : s[o]] : [];
      return [r].flat().reduce((a, d) => {
        if (d != null) {
          let u = typeof d;
          if (u === "string" || u === "number") a.push(d);
          else if (u === "object") {
            let c = Array.isArray(d) ? n(o, d) : Object.entries(d).map(([p, m]) => o === "style" && (m || m === 0) ? `${p.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}:${m}` : m ? p : void 0);
            a = c.length ? a.concat(c.filter((p) => !!p)) : a;
          }
        }
        return a;
      }, i);
    };
    Object.entries(t).forEach(([o, r]) => {
      if (r != null) {
        let l = o.match(/^on(.+)/);
        l ? e.addEventListener(l[1].toLowerCase(), r) : o === "p-bind" || o === "pBind" ? nt(e, r) : (r = o === "class" ? [...new Set(n("class", r))].join(" ").trim() : o === "style" ? n("style", r).join(";").trim() : r, (e.$attrs = e.$attrs || {}) && (e.$attrs[o] = r), e.setAttribute(o, r));
      }
    });
  }
}
function bo(e, t = {}, ...n) {
  {
    let o = document.createElement(e);
    return nt(o, t), o.append(...n), o;
  }
}
function go(e, t) {
  return Ye(e) ? e.matches(t) ? e : e.querySelector(t) : null;
}
function vo(e, t) {
  if (Ye(e)) {
    let n = e.getAttribute(t);
    return isNaN(n) ? n === "true" || n === "false" ? n === "true" : n : +n;
  }
}
function Vt(e) {
  if (e) {
    let t = e.offsetHeight, n = getComputedStyle(e);
    return t -= parseFloat(n.paddingTop) + parseFloat(n.paddingBottom) + parseFloat(n.borderTopWidth) + parseFloat(n.borderBottomWidth), t;
  }
  return 0;
}
function ho(e) {
  if (e) {
    let t = e.getBoundingClientRect();
    return { top: t.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0), left: t.left + (window.pageXOffset || It(document.documentElement) || It(document.body) || 0) };
  }
  return { top: "auto", left: "auto" };
}
function yo(e, t) {
  return e ? e.offsetHeight : 0;
}
function Dt(e) {
  if (e) {
    let t = e.offsetWidth, n = getComputedStyle(e);
    return t -= parseFloat(n.paddingLeft) + parseFloat(n.paddingRight) + parseFloat(n.borderLeftWidth) + parseFloat(n.borderRightWidth), t;
  }
  return 0;
}
function $o() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function _o(e, t = "", n) {
  Ye(e) && n !== null && n !== void 0 && e.setAttribute(t, n);
}
function hn() {
  let e = /* @__PURE__ */ new Map();
  return { on(t, n) {
    let o = e.get(t);
    return o ? o.push(n) : o = [n], e.set(t, o), this;
  }, off(t, n) {
    let o = e.get(t);
    return o && o.splice(o.indexOf(n) >>> 0, 1), this;
  }, emit(t, n) {
    let o = e.get(t);
    o && o.forEach((r) => {
      r(n);
    });
  }, clear() {
    e.clear();
  } };
}
function Se(e) {
  return e == null || e === "" || Array.isArray(e) && e.length === 0 || !(e instanceof Date) && typeof e == "object" && Object.keys(e).length === 0;
}
function Tt(e) {
  return typeof e == "function" && "call" in e && "apply" in e;
}
function E(e) {
  return !Se(e);
}
function ve(e, t = !0) {
  return e instanceof Object && e.constructor === Object && (t || Object.keys(e).length !== 0);
}
function ne(e, ...t) {
  return Tt(e) ? e(...t) : e;
}
function ee(e, t = !0) {
  return typeof e == "string" && (t || e !== "");
}
function se(e) {
  return ee(e) ? e.replace(/(-|_)/g, "").toLowerCase() : e;
}
function jt(e, t = "", n = {}) {
  let o = se(t).split("."), r = o.shift();
  if (r) {
    if (ve(e)) {
      let l = Object.keys(e).find((s) => se(s) === r) || "";
      return jt(ne(e[l], n), o.join("."), n);
    }
    return;
  }
  return ne(e, n);
}
function yn(e, t = !0) {
  return Array.isArray(e) && (t || e.length !== 0);
}
function ko(e) {
  return E(e) && !isNaN(e);
}
function $e(e, t) {
  if (t) {
    let n = t.test(e);
    return t.lastIndex = 0, n;
  }
  return !1;
}
function Le(e) {
  return e && e.replace(/\/\*(?:(?!\*\/)[\s\S])*\*\/|[\r\n\t]+/g, "").replace(/ {2,}/g, " ").replace(/ ([{:}]) /g, "$1").replace(/([;,]) /g, "$1").replace(/ !/g, "!").replace(/: /g, ":").trim();
}
function So(e) {
  return ee(e, !1) ? e[0].toUpperCase() + e.slice(1) : e;
}
function $n(e) {
  return ee(e) ? e.replace(/(_)/g, "-").replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase() : e;
}
var qe = {};
function wo(e = "pui_id_") {
  return Object.hasOwn(qe, e) || (qe[e] = 0), qe[e]++, `${e}${qe[e]}`;
}
var Po = Object.defineProperty, xo = Object.defineProperties, Co = Object.getOwnPropertyDescriptors, ot = Object.getOwnPropertySymbols, _n = Object.prototype.hasOwnProperty, kn = Object.prototype.propertyIsEnumerable, Bt = (e, t, n) => t in e ? Po(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, ie = (e, t) => {
  for (var n in t || (t = {})) _n.call(t, n) && Bt(e, n, t[n]);
  if (ot) for (var n of ot(t)) kn.call(t, n) && Bt(e, n, t[n]);
  return e;
}, ht = (e, t) => xo(e, Co(t)), ce = (e, t) => {
  var n = {};
  for (var o in e) _n.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && ot) for (var o of ot(e)) t.indexOf(o) < 0 && kn.call(e, o) && (n[o] = e[o]);
  return n;
}, Oo = hn(), q = Oo, ze = /{([^}]*)}/g, Sn = /(\d+\s+[\+\-\*\/]\s+\d+)/g, wn = /var\([^)]+\)/g;
function Ft(e) {
  return ee(e) ? e.replace(/[A-Z]/g, (t, n) => n === 0 ? t : "." + t.toLowerCase()).toLowerCase() : e;
}
function To(e) {
  return ve(e) && e.hasOwnProperty("$value") && e.hasOwnProperty("$type") ? e.$value : e;
}
function jo(e) {
  return e.replaceAll(/ /g, "").replace(/[^\w]/g, "-");
}
function kt(e = "", t = "") {
  return jo(`${ee(e, !1) && ee(t, !1) ? `${e}-` : e}${t}`);
}
function Pn(e = "", t = "") {
  return `--${kt(e, t)}`;
}
function No(e = "") {
  let t = (e.match(/{/g) || []).length, n = (e.match(/}/g) || []).length;
  return (t + n) % 2 !== 0;
}
function xn(e, t = "", n = "", o = [], r) {
  if (ee(e)) {
    let l = e.trim();
    if (No(l)) return;
    if ($e(l, ze)) {
      let s = l.replaceAll(ze, (i) => {
        let a = i.replace(/{|}/g, "").split(".").filter((d) => !o.some((u) => $e(d, u)));
        return `var(${Pn(n, $n(a.join("-")))}${E(r) ? `, ${r}` : ""})`;
      });
      return $e(s.replace(wn, "0"), Sn) ? `calc(${s})` : s;
    }
    return l;
  } else if (ko(e)) return e;
}
function Lo(e, t, n) {
  ee(t, !1) && e.push(`${t}:${n};`);
}
function Pe(e, t) {
  return e ? `${e}{${t}}` : "";
}
function Cn(e, t) {
  if (e.indexOf("dt(") === -1) return e;
  function n(s, i) {
    let a = [], d = 0, u = "", c = null, p = 0;
    for (; d <= s.length; ) {
      let m = s[d];
      if ((m === '"' || m === "'" || m === "`") && s[d - 1] !== "\\" && (c = c === m ? null : m), !c && (m === "(" && p++, m === ")" && p--, (m === "," || d === s.length) && p === 0)) {
        let b = u.trim();
        b.startsWith("dt(") ? a.push(Cn(b, i)) : a.push(o(b)), u = "", d++;
        continue;
      }
      m !== void 0 && (u += m), d++;
    }
    return a;
  }
  function o(s) {
    let i = s[0];
    if ((i === '"' || i === "'" || i === "`") && s[s.length - 1] === i) return s.slice(1, -1);
    let a = Number(s);
    return isNaN(a) ? s : a;
  }
  let r = [], l = [];
  for (let s = 0; s < e.length; s++) if (e[s] === "d" && e.slice(s, s + 3) === "dt(") l.push(s), s += 2;
  else if (e[s] === ")" && l.length > 0) {
    let i = l.pop();
    l.length === 0 && r.push([i, s]);
  }
  if (!r.length) return e;
  for (let s = r.length - 1; s >= 0; s--) {
    let [i, a] = r[s], d = e.slice(i + 3, a), u = n(d, t), c = t(...u);
    e = e.slice(0, i) + c + e.slice(a + 1);
  }
  return e;
}
var _e = (...e) => Eo(I.getTheme(), ...e), Eo = (e = {}, t, n, o) => {
  if (t) {
    let { variable: r, options: l } = I.defaults || {}, { prefix: s, transform: i } = e?.options || l || {}, a = $e(t, ze) ? t : `{${t}}`;
    return o === "value" || Se(o) && i === "strict" ? I.getTokenValue(t) : xn(a, void 0, s, [r.excludedKeyRegex], n);
  }
  return "";
};
function Xe(e, ...t) {
  if (e instanceof Array) {
    let n = e.reduce((o, r, l) => {
      var s;
      return o + r + ((s = ne(t[l], { dt: _e })) != null ? s : "");
    }, "");
    return Cn(n, _e);
  }
  return ne(e, { dt: _e });
}
function zo(e, t = {}) {
  let n = I.defaults.variable, { prefix: o = n.prefix, selector: r = n.selector, excludedKeyRegex: l = n.excludedKeyRegex } = t, s = [], i = [], a = [{ node: e, path: o }];
  for (; a.length; ) {
    let { node: u, path: c } = a.pop();
    for (let p in u) {
      let m = u[p], b = To(m), v = $e(p, l) ? kt(c) : kt(c, $n(p));
      if (ve(b)) a.push({ node: b, path: v });
      else {
        let g = Pn(v), $ = xn(b, v, o, [l]);
        Lo(i, g, $);
        let S = v;
        o && S.startsWith(o + "-") && (S = S.slice(o.length + 1)), s.push(S.replace(/-/g, "."));
      }
    }
  }
  let d = i.join("");
  return { value: i, tokens: s, declarations: d, css: Pe(r, d) };
}
var ae = { regex: { rules: { class: { pattern: /^\.([a-zA-Z][\w-]*)$/, resolve(e) {
  return { type: "class", selector: e, matched: this.pattern.test(e.trim()) };
} }, attr: { pattern: /^\[(.*)\]$/, resolve(e) {
  return { type: "attr", selector: `:root${e},:host${e}`, matched: this.pattern.test(e.trim()) };
} }, media: { pattern: /^@media (.*)$/, resolve(e) {
  return { type: "media", selector: e, matched: this.pattern.test(e.trim()) };
} }, system: { pattern: /^system$/, resolve(e) {
  return { type: "system", selector: "@media (prefers-color-scheme: dark)", matched: this.pattern.test(e.trim()) };
} }, custom: { resolve(e) {
  return { type: "custom", selector: e, matched: !0 };
} } }, resolve(e) {
  let t = Object.keys(this.rules).filter((n) => n !== "custom").map((n) => this.rules[n]);
  return [e].flat().map((n) => {
    var o;
    return (o = t.map((r) => r.resolve(n)).find((r) => r.matched)) != null ? o : this.rules.custom.resolve(n);
  });
} }, _toVariables(e, t) {
  return zo(e, { prefix: t?.prefix });
}, getCommon({ name: e = "", theme: t = {}, params: n, set: o, defaults: r }) {
  var l, s, i, a, d, u, c;
  let { preset: p, options: m } = t, b, v, g, $, S, O, f;
  if (E(p) && m.transform !== "strict") {
    let { primitive: y, semantic: _, extend: x } = p, A = _ || {}, { colorScheme: K } = A, W = ce(A, ["colorScheme"]), B = x || {}, { colorScheme: G } = B, X = ce(B, ["colorScheme"]), Q = K || {}, { dark: Z } = Q, T = ce(Q, ["dark"]), F = G || {}, { dark: de } = F, H = ce(F, ["dark"]), re = E(y) ? this._toVariables({ primitive: y }, m) : {}, te = E(W) ? this._toVariables({ semantic: W }, m) : {}, ue = E(T) ? this._toVariables({ light: T }, m) : {}, we = E(Z) ? this._toVariables({ dark: Z }, m) : {}, me = E(X) ? this._toVariables({ semantic: X }, m) : {}, Ze = E(H) ? this._toVariables({ light: H }, m) : {}, Oe = E(de) ? this._toVariables({ dark: de }, m) : {}, [it, lt] = [(l = re.declarations) != null ? l : "", re.tokens], [st, dt] = [(s = te.declarations) != null ? s : "", te.tokens || []], [ut, Te] = [(i = ue.declarations) != null ? i : "", ue.tokens || []], [ct, pt] = [(a = we.declarations) != null ? a : "", we.tokens || []], [h, L] = [(d = me.declarations) != null ? d : "", me.tokens || []], [Vn, Dn] = [(u = Ze.declarations) != null ? u : "", Ze.tokens || []], [Bn, Fn] = [(c = Oe.declarations) != null ? c : "", Oe.tokens || []];
    b = this.transformCSS(e, it, "light", "variable", m, o, r), v = lt;
    let Mn = this.transformCSS(e, `${st}${ut}`, "light", "variable", m, o, r), Un = this.transformCSS(e, `${ct}`, "dark", "variable", m, o, r);
    g = `${Mn}${Un}`, $ = [.../* @__PURE__ */ new Set([...dt, ...Te, ...pt])];
    let Rn = this.transformCSS(e, `${h}${Vn}color-scheme:light`, "light", "variable", m, o, r), Kn = this.transformCSS(e, `${Bn}color-scheme:dark`, "dark", "variable", m, o, r);
    S = `${Rn}${Kn}`, O = [.../* @__PURE__ */ new Set([...L, ...Dn, ...Fn])], f = ne(p.css, { dt: _e });
  }
  return { primitive: { css: b, tokens: v }, semantic: { css: g, tokens: $ }, global: { css: S, tokens: O }, style: f };
}, getPreset({ name: e = "", preset: t = {}, options: n, params: o, set: r, defaults: l, selector: s }) {
  var i, a, d;
  let u, c, p;
  if (E(t) && n.transform !== "strict") {
    let m = e.replace("-directive", ""), b = t, { colorScheme: v, extend: g, css: $ } = b, S = ce(b, ["colorScheme", "extend", "css"]), O = g || {}, { colorScheme: f } = O, y = ce(O, ["colorScheme"]), _ = v || {}, { dark: x } = _, A = ce(_, ["dark"]), K = f || {}, { dark: W } = K, B = ce(K, ["dark"]), G = E(S) ? this._toVariables({ [m]: ie(ie({}, S), y) }, n) : {}, X = E(A) ? this._toVariables({ [m]: ie(ie({}, A), B) }, n) : {}, Q = E(x) ? this._toVariables({ [m]: ie(ie({}, x), W) }, n) : {}, [Z, T] = [(i = G.declarations) != null ? i : "", G.tokens || []], [F, de] = [(a = X.declarations) != null ? a : "", X.tokens || []], [H, re] = [(d = Q.declarations) != null ? d : "", Q.tokens || []], te = this.transformCSS(m, `${Z}${F}`, "light", "variable", n, r, l, s), ue = this.transformCSS(m, H, "dark", "variable", n, r, l, s);
    u = `${te}${ue}`, c = [.../* @__PURE__ */ new Set([...T, ...de, ...re])], p = ne($, { dt: _e });
  }
  return { css: u, tokens: c, style: p };
}, getPresetC({ name: e = "", theme: t = {}, params: n, set: o, defaults: r }) {
  var l;
  let { preset: s, options: i } = t, a = (l = s?.components) == null ? void 0 : l[e];
  return this.getPreset({ name: e, preset: a, options: i, params: n, set: o, defaults: r });
}, getPresetD({ name: e = "", theme: t = {}, params: n, set: o, defaults: r }) {
  var l, s;
  let i = e.replace("-directive", ""), { preset: a, options: d } = t, u = ((l = a?.components) == null ? void 0 : l[i]) || ((s = a?.directives) == null ? void 0 : s[i]);
  return this.getPreset({ name: i, preset: u, options: d, params: n, set: o, defaults: r });
}, applyDarkColorScheme(e) {
  return !(e.darkModeSelector === "none" || e.darkModeSelector === !1);
}, getColorSchemeOption(e, t) {
  var n;
  return this.applyDarkColorScheme(e) ? this.regex.resolve(e.darkModeSelector === !0 ? t.options.darkModeSelector : (n = e.darkModeSelector) != null ? n : t.options.darkModeSelector) : [];
}, getLayerOrder(e, t = {}, n, o) {
  let { cssLayer: r } = t;
  return r ? `@layer ${ne(r.order || r.name || "primeui", n)}` : "";
}, getCommonStyleSheet({ name: e = "", theme: t = {}, params: n, props: o = {}, set: r, defaults: l }) {
  let s = this.getCommon({ name: e, theme: t, params: n, set: r, defaults: l }), i = Object.entries(o).reduce((a, [d, u]) => a.push(`${d}="${u}"`) && a, []).join(" ");
  return Object.entries(s || {}).reduce((a, [d, u]) => {
    if (ve(u) && Object.hasOwn(u, "css")) {
      let c = Le(u.css), p = `${d}-variables`;
      a.push(`<style type="text/css" data-primevue-style-id="${p}" ${i}>${c}</style>`);
    }
    return a;
  }, []).join("");
}, getStyleSheet({ name: e = "", theme: t = {}, params: n, props: o = {}, set: r, defaults: l }) {
  var s;
  let i = { name: e, theme: t, params: n, set: r, defaults: l }, a = (s = e.includes("-directive") ? this.getPresetD(i) : this.getPresetC(i)) == null ? void 0 : s.css, d = Object.entries(o).reduce((u, [c, p]) => u.push(`${c}="${p}"`) && u, []).join(" ");
  return a ? `<style type="text/css" data-primevue-style-id="${e}-variables" ${d}>${Le(a)}</style>` : "";
}, createTokens(e = {}, t, n = "", o = "", r = {}) {
  let l = function(i, a = {}, d = []) {
    if (d.includes(this.path)) return console.warn(`Circular reference detected at ${this.path}`), { colorScheme: i, path: this.path, paths: a, value: void 0 };
    d.push(this.path), a.name = this.path, a.binding || (a.binding = {});
    let u = this.value;
    if (typeof this.value == "string" && ze.test(this.value)) {
      let c = this.value.trim().replace(ze, (p) => {
        var m;
        let b = p.slice(1, -1), v = this.tokens[b];
        if (!v) return console.warn(`Token not found for path: ${b}`), "__UNRESOLVED__";
        let g = v.computed(i, a, d);
        return Array.isArray(g) && g.length === 2 ? `light-dark(${g[0].value},${g[1].value})` : (m = g?.value) != null ? m : "__UNRESOLVED__";
      });
      u = Sn.test(c.replace(wn, "0")) ? `calc(${c})` : c;
    }
    return Se(a.binding) && delete a.binding, d.pop(), { colorScheme: i, path: this.path, paths: a, value: u.includes("__UNRESOLVED__") ? void 0 : u };
  }, s = (i, a, d) => {
    Object.entries(i).forEach(([u, c]) => {
      let p = $e(u, t.variable.excludedKeyRegex) ? a : a ? `${a}.${Ft(u)}` : Ft(u), m = d ? `${d}.${u}` : u;
      ve(c) ? s(c, p, m) : (r[p] || (r[p] = { paths: [], computed: (b, v = {}, g = []) => {
        if (r[p].paths.length === 1) return r[p].paths[0].computed(r[p].paths[0].scheme, v.binding, g);
        if (b && b !== "none") for (let $ = 0; $ < r[p].paths.length; $++) {
          let S = r[p].paths[$];
          if (S.scheme === b) return S.computed(b, v.binding, g);
        }
        return r[p].paths.map(($) => $.computed($.scheme, v[$.scheme], g));
      } }), r[p].paths.push({ path: m, value: c, scheme: m.includes("colorScheme.light") ? "light" : m.includes("colorScheme.dark") ? "dark" : "none", computed: l, tokens: r }));
    });
  };
  return s(e, n, o), r;
}, getTokenValue(e, t, n) {
  var o;
  let r = ((i) => i.split(".").filter((a) => !$e(a.toLowerCase(), n.variable.excludedKeyRegex)).join("."))(t), l = t.includes("colorScheme.light") ? "light" : t.includes("colorScheme.dark") ? "dark" : void 0, s = [(o = e[r]) == null ? void 0 : o.computed(l)].flat().filter((i) => i);
  return s.length === 1 ? s[0].value : s.reduce((i = {}, a) => {
    let d = a, { colorScheme: u } = d, c = ce(d, ["colorScheme"]);
    return i[u] = c, i;
  }, void 0);
}, getSelectorRule(e, t, n, o) {
  return n === "class" || n === "attr" ? Pe(E(t) ? `${e}${t},${e} ${t}` : e, o) : Pe(e, Pe(t ?? ":root,:host", o));
}, transformCSS(e, t, n, o, r = {}, l, s, i) {
  if (E(t)) {
    let { cssLayer: a } = r;
    if (o !== "style") {
      let d = this.getColorSchemeOption(r, s);
      t = n === "dark" ? d.reduce((u, { type: c, selector: p }) => (E(p) && (u += p.includes("[CSS]") ? p.replace("[CSS]", t) : this.getSelectorRule(p, i, c, t)), u), "") : Pe(i ?? ":root,:host", t);
    }
    if (a) {
      let d = { name: "primeui" };
      ve(a) && (d.name = ne(a.name, { name: e, type: o })), E(d.name) && (t = Pe(`@layer ${d.name}`, t), l?.layerNames(d.name));
    }
    return t;
  }
  return "";
} }, I = { defaults: { variable: { prefix: "p", selector: ":root,:host", excludedKeyRegex: /^(primitive|semantic|components|directives|variables|colorscheme|light|dark|common|root|states|extend|css)$/gi }, options: { prefix: "p", darkModeSelector: "system", cssLayer: !1 } }, _theme: void 0, _layerNames: /* @__PURE__ */ new Set(), _loadedStyleNames: /* @__PURE__ */ new Set(), _loadingStyles: /* @__PURE__ */ new Set(), _tokens: {}, update(e = {}) {
  let { theme: t } = e;
  t && (this._theme = ht(ie({}, t), { options: ie(ie({}, this.defaults.options), t.options) }), this._tokens = ae.createTokens(this.preset, this.defaults), this.clearLoadedStyleNames());
}, get theme() {
  return this._theme;
}, get preset() {
  var e;
  return ((e = this.theme) == null ? void 0 : e.preset) || {};
}, get options() {
  var e;
  return ((e = this.theme) == null ? void 0 : e.options) || {};
}, get tokens() {
  return this._tokens;
}, getTheme() {
  return this.theme;
}, setTheme(e) {
  this.update({ theme: e }), q.emit("theme:change", e);
}, getPreset() {
  return this.preset;
}, setPreset(e) {
  this._theme = ht(ie({}, this.theme), { preset: e }), this._tokens = ae.createTokens(e, this.defaults), this.clearLoadedStyleNames(), q.emit("preset:change", e), q.emit("theme:change", this.theme);
}, getOptions() {
  return this.options;
}, setOptions(e) {
  this._theme = ht(ie({}, this.theme), { options: e }), this.clearLoadedStyleNames(), q.emit("options:change", e), q.emit("theme:change", this.theme);
}, getLayerNames() {
  return [...this._layerNames];
}, setLayerNames(e) {
  this._layerNames.add(e);
}, getLoadedStyleNames() {
  return this._loadedStyleNames;
}, isStyleNameLoaded(e) {
  return this._loadedStyleNames.has(e);
}, setLoadedStyleName(e) {
  this._loadedStyleNames.add(e);
}, deleteLoadedStyleName(e) {
  this._loadedStyleNames.delete(e);
}, clearLoadedStyleNames() {
  this._loadedStyleNames.clear();
}, getTokenValue(e) {
  return ae.getTokenValue(this.tokens, e, this.defaults);
}, getCommon(e = "", t) {
  return ae.getCommon({ name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, getComponent(e = "", t) {
  let n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return ae.getPresetC(n);
}, getDirective(e = "", t) {
  let n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return ae.getPresetD(n);
}, getCustomPreset(e = "", t, n, o) {
  let r = { name: e, preset: t, options: this.options, selector: n, params: o, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return ae.getPreset(r);
}, getLayerOrderCSS(e = "") {
  return ae.getLayerOrder(e, this.options, { names: this.getLayerNames() }, this.defaults);
}, transformCSS(e = "", t, n = "style", o) {
  return ae.transformCSS(e, t, o, n, this.options, { layerNames: this.setLayerNames.bind(this) }, this.defaults);
}, getCommonStyleSheet(e = "", t, n = {}) {
  return ae.getCommonStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, getStyleSheet(e, t, n = {}) {
  return ae.getStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, onStyleMounted(e) {
  this._loadingStyles.add(e);
}, onStyleUpdated(e) {
  this._loadingStyles.add(e);
}, onStyleLoaded(e, { name: t }) {
  this._loadingStyles.size && (this._loadingStyles.delete(t), q.emit(`theme:${t}:load`, e), !this._loadingStyles.size && q.emit("theme:load"));
} }, ge = {
  _loadedStyleNames: /* @__PURE__ */ new Set(),
  getLoadedStyleNames: function() {
    return this._loadedStyleNames;
  },
  isStyleNameLoaded: function(t) {
    return this._loadedStyleNames.has(t);
  },
  setLoadedStyleName: function(t) {
    this._loadedStyleNames.add(t);
  },
  deleteLoadedStyleName: function(t) {
    this._loadedStyleNames.delete(t);
  },
  clearLoadedStyleNames: function() {
    this._loadedStyleNames.clear();
  }
}, Ao = `
    *,
    ::before,
    ::after {
        box-sizing: border-box;
    }

    .p-collapsible-enter-active {
        animation: p-animate-collapsible-expand 0.2s ease-out;
        overflow: hidden;
    }

    .p-collapsible-leave-active {
        animation: p-animate-collapsible-collapse 0.2s ease-out;
        overflow: hidden;
    }

    @keyframes p-animate-collapsible-expand {
        from {
            grid-template-rows: 0fr;
        }
        to {
            grid-template-rows: 1fr;
        }
    }

    @keyframes p-animate-collapsible-collapse {
        from {
            grid-template-rows: 1fr;
        }
        to {
            grid-template-rows: 0fr;
        }
    }

    .p-disabled,
    .p-disabled * {
        cursor: default;
        pointer-events: none;
        user-select: none;
    }

    .p-disabled,
    .p-component:disabled {
        opacity: dt('disabled.opacity');
    }

    .pi {
        font-size: dt('icon.size');
    }

    .p-icon {
        width: dt('icon.size');
        height: dt('icon.size');
    }

    .p-overlay-mask {
        background: var(--px-mask-background, dt('mask.background'));
        color: dt('mask.color');
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .p-overlay-mask-enter-active {
        animation: p-animate-overlay-mask-enter dt('mask.transition.duration') forwards;
    }

    .p-overlay-mask-leave-active {
        animation: p-animate-overlay-mask-leave dt('mask.transition.duration') forwards;
    }

    @keyframes p-animate-overlay-mask-enter {
        from {
            background: transparent;
        }
        to {
            background: var(--px-mask-background, dt('mask.background'));
        }
    }
    @keyframes p-animate-overlay-mask-leave {
        from {
            background: var(--px-mask-background, dt('mask.background'));
        }
        to {
            background: transparent;
        }
    }

    .p-anchored-overlay-enter-active {
        animation: p-animate-anchored-overlay-enter 300ms cubic-bezier(.19,1,.22,1);
    }

    .p-anchored-overlay-leave-active {
        animation: p-animate-anchored-overlay-leave 300ms cubic-bezier(.19,1,.22,1);
    }

    @keyframes p-animate-anchored-overlay-enter {
        from {
            opacity: 0;
            transform: scale(0.93);
        }
    }

    @keyframes p-animate-anchored-overlay-leave {
        to {
            opacity: 0;
            transform: scale(0.93);
        }
    }
`;
function Ae(e) {
  "@babel/helpers - typeof";
  return Ae = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ae(e);
}
function Mt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Ut(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mt(Object(n), !0).forEach(function(o) {
      Io(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mt(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Io(e, t, n) {
  return (t = Vo(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Vo(e) {
  var t = Do(e, "string");
  return Ae(t) == "symbol" ? t : t + "";
}
function Do(e, t) {
  if (Ae(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Ae(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Bo(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  Nt() && Nt().components ? un(e) : t ? e() : Hn(e);
}
var Fo = 0;
function Mo(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = M(!1), o = M(e), r = M(null), l = $o() ? window.document : void 0, s = t.document, i = s === void 0 ? l : s, a = t.immediate, d = a === void 0 ? !0 : a, u = t.manual, c = u === void 0 ? !1 : u, p = t.name, m = p === void 0 ? "style_".concat(++Fo) : p, b = t.id, v = b === void 0 ? void 0 : b, g = t.media, $ = g === void 0 ? void 0 : g, S = t.nonce, O = S === void 0 ? void 0 : S, f = t.first, y = f === void 0 ? !1 : f, _ = t.onMounted, x = _ === void 0 ? void 0 : _, A = t.onUpdated, K = A === void 0 ? void 0 : A, W = t.onLoad, B = W === void 0 ? void 0 : W, G = t.props, X = G === void 0 ? {} : G, Q = function() {
  }, Z = function(de) {
    var H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (i) {
      var re = Ut(Ut({}, X), H), te = re.name || m, ue = re.id || v, we = re.nonce || O;
      r.value = i.querySelector('style[data-primevue-style-id="'.concat(te, '"]')) || i.getElementById(ue) || i.createElement("style"), r.value.isConnected || (o.value = de || e, nt(r.value, {
        type: "text/css",
        id: ue,
        media: $,
        nonce: we
      }), y ? i.head.prepend(r.value) : i.head.appendChild(r.value), _o(r.value, "data-primevue-style-id", te), nt(r.value, re), r.value.onload = function(me) {
        return B?.(me, {
          name: te
        });
      }, x?.(te)), !n.value && (Q = be(o, function(me) {
        r.value.textContent = me, K?.(te);
      }, {
        immediate: !0
      }), n.value = !0);
    }
  }, T = function() {
    !i || !n.value || (Q(), fo(r.value) && i.head.removeChild(r.value), n.value = !1, r.value = null);
  };
  return d && !c && Bo(Z), {
    id: v,
    name: m,
    el: r,
    css: o,
    unload: T,
    load: Z,
    isLoaded: Wn(n)
  };
}
function Ie(e) {
  "@babel/helpers - typeof";
  return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ie(e);
}
var Rt, Kt, Wt, Ht;
function Yt(e, t) {
  return Wo(e) || Ko(e, t) || Ro(e, t) || Uo();
}
function Uo() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ro(e, t) {
  if (e) {
    if (typeof e == "string") return Gt(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Gt(e, t) : void 0;
  }
}
function Gt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Ko(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o, r, l, s, i = [], a = !0, d = !1;
    try {
      if (l = (n = n.call(e)).next, t !== 0) for (; !(a = (o = l.call(n)).done) && (i.push(o.value), i.length !== t); a = !0) ;
    } catch (u) {
      d = !0, r = u;
    } finally {
      try {
        if (!a && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (d) throw r;
      }
    }
    return i;
  }
}
function Wo(e) {
  if (Array.isArray(e)) return e;
}
function Zt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function yt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zt(Object(n), !0).forEach(function(o) {
      Ho(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zt(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Ho(e, t, n) {
  return (t = Yo(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Yo(e) {
  var t = Go(e, "string");
  return Ie(t) == "symbol" ? t : t + "";
}
function Go(e, t) {
  if (Ie(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Ie(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Qe(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var Zo = function(t) {
  var n = t.dt;
  return `
.p-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    opacity: 0;
    overflow: hidden;
    padding: 0;
    pointer-events: none;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

.p-overflow-hidden {
    overflow: hidden;
    padding-right: `.concat(n("scrollbar.width"), `;
}
`);
}, qo = {}, Xo = {}, R = {
  name: "base",
  css: Zo,
  style: Ao,
  classes: qo,
  inlineStyles: Xo,
  load: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(l) {
      return l;
    }, r = o(Xe(Rt || (Rt = Qe(["", ""])), t));
    return E(r) ? Mo(Le(r), yt({
      name: this.name
    }, n)) : {};
  },
  loadCSS: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.load(this.css, t);
  },
  loadStyle: function() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return this.load(this.style, n, function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return I.transformCSS(n.name || t.name, "".concat(r).concat(Xe(Kt || (Kt = Qe(["", ""])), o)));
    });
  },
  getCommonTheme: function(t) {
    return I.getCommon(this.name, t);
  },
  getComponentTheme: function(t) {
    return I.getComponent(this.name, t);
  },
  getDirectiveTheme: function(t) {
    return I.getDirective(this.name, t);
  },
  getPresetTheme: function(t, n, o) {
    return I.getCustomPreset(this.name, t, n, o);
  },
  getLayerOrderThemeCSS: function() {
    return I.getLayerOrderCSS(this.name);
  },
  getStyleSheet: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.css) {
      var o = ne(this.css, {
        dt: _e
      }) || "", r = Le(Xe(Wt || (Wt = Qe(["", "", ""])), o, t)), l = Object.entries(n).reduce(function(s, i) {
        var a = Yt(i, 2), d = a[0], u = a[1];
        return s.push("".concat(d, '="').concat(u, '"')) && s;
      }, []).join(" ");
      return E(r) ? '<style type="text/css" data-primevue-style-id="'.concat(this.name, '" ').concat(l, ">").concat(r, "</style>") : "";
    }
    return "";
  },
  getCommonThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return I.getCommonStyleSheet(this.name, t, n);
  },
  getThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = [I.getStyleSheet(this.name, t, n)];
    if (this.style) {
      var r = this.name === "base" ? "global-style" : "".concat(this.name, "-style"), l = Xe(Ht || (Ht = Qe(["", ""])), ne(this.style, {
        dt: _e
      })), s = Le(I.transformCSS(r, l)), i = Object.entries(n).reduce(function(a, d) {
        var u = Yt(d, 2), c = u[0], p = u[1];
        return a.push("".concat(c, '="').concat(p, '"')) && a;
      }, []).join(" ");
      E(s) && o.push('<style type="text/css" data-primevue-style-id="'.concat(r, '" ').concat(i, ">").concat(s, "</style>"));
    }
    return o.join("");
  },
  extend: function(t) {
    return yt(yt({}, this), {}, {
      css: void 0,
      style: void 0
    }, t);
  }
};
function Qo() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "pc", t = et();
  return "".concat(e).concat(t.replace("v-", "").replaceAll("-", "_"));
}
var qt = R.extend({
  name: "common"
});
function Ve(e) {
  "@babel/helpers - typeof";
  return Ve = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ve(e);
}
function Jo(e) {
  return jn(e) || er(e) || Tn(e) || On();
}
function er(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function je(e, t) {
  return jn(e) || tr(e, t) || Tn(e, t) || On();
}
function On() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tn(e, t) {
  if (e) {
    if (typeof e == "string") return St(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? St(e, t) : void 0;
  }
}
function St(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function tr(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o, r, l, s, i = [], a = !0, d = !1;
    try {
      if (l = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        a = !1;
      } else for (; !(a = (o = l.call(n)).done) && (i.push(o.value), i.length !== t); a = !0) ;
    } catch (u) {
      d = !0, r = u;
    } finally {
      try {
        if (!a && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (d) throw r;
      }
    }
    return i;
  }
}
function jn(e) {
  if (Array.isArray(e)) return e;
}
function Xt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function P(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xt(Object(n), !0).forEach(function(o) {
      Ne(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xt(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Ne(e, t, n) {
  return (t = nr(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nr(e) {
  var t = or(e, "string");
  return Ve(t) == "symbol" ? t : t + "";
}
function or(e, t) {
  if (Ve(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Ve(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ge = {
  name: "BaseComponent",
  props: {
    pt: {
      type: Object,
      default: void 0
    },
    ptOptions: {
      type: Object,
      default: void 0
    },
    unstyled: {
      type: Boolean,
      default: void 0
    },
    dt: {
      type: Object,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    }
  },
  watch: {
    isUnstyled: {
      immediate: !0,
      handler: function(t) {
        q.off("theme:change", this._loadCoreStyles), t || (this._loadCoreStyles(), this._themeChangeListener(this._loadCoreStyles));
      }
    },
    dt: {
      immediate: !0,
      handler: function(t, n) {
        var o = this;
        q.off("theme:change", this._themeScopedListener), t ? (this._loadScopedThemeStyles(t), this._themeScopedListener = function() {
          return o._loadScopedThemeStyles(t);
        }, this._themeChangeListener(this._themeScopedListener)) : this._unloadScopedThemeStyles();
      }
    }
  },
  scopedStyleEl: void 0,
  rootEl: void 0,
  uid: void 0,
  $attrSelector: void 0,
  beforeCreate: function() {
    var t, n, o, r, l, s, i, a, d, u, c, p = (t = this.pt) === null || t === void 0 ? void 0 : t._usept, m = p ? (n = this.pt) === null || n === void 0 || (n = n.originalValue) === null || n === void 0 ? void 0 : n[this.$.type.name] : void 0, b = p ? (o = this.pt) === null || o === void 0 || (o = o.value) === null || o === void 0 ? void 0 : o[this.$.type.name] : this.pt;
    (r = b || m) === null || r === void 0 || (r = r.hooks) === null || r === void 0 || (l = r.onBeforeCreate) === null || l === void 0 || l.call(r);
    var v = (s = this.$primevueConfig) === null || s === void 0 || (s = s.pt) === null || s === void 0 ? void 0 : s._usept, g = v ? (i = this.$primevue) === null || i === void 0 || (i = i.config) === null || i === void 0 || (i = i.pt) === null || i === void 0 ? void 0 : i.originalValue : void 0, $ = v ? (a = this.$primevue) === null || a === void 0 || (a = a.config) === null || a === void 0 || (a = a.pt) === null || a === void 0 ? void 0 : a.value : (d = this.$primevue) === null || d === void 0 || (d = d.config) === null || d === void 0 ? void 0 : d.pt;
    (u = $ || g) === null || u === void 0 || (u = u[this.$.type.name]) === null || u === void 0 || (u = u.hooks) === null || u === void 0 || (c = u.onBeforeCreate) === null || c === void 0 || c.call(u), this.$attrSelector = Qo(), this.uid = this.$attrs.id || this.$attrSelector.replace("pc", "pv_id_");
  },
  created: function() {
    this._hook("onCreated");
  },
  beforeMount: function() {
    var t;
    this.rootEl = go(Ye(this.$el) ? this.$el : (t = this.$el) === null || t === void 0 ? void 0 : t.parentElement, "[".concat(this.$attrSelector, "]")), this.rootEl && (this.rootEl.$pc = P({
      name: this.$.type.name,
      attrSelector: this.$attrSelector
    }, this.$params)), this._loadStyles(), this._hook("onBeforeMount");
  },
  mounted: function() {
    this._hook("onMounted");
  },
  beforeUpdate: function() {
    this._hook("onBeforeUpdate");
  },
  updated: function() {
    this._hook("onUpdated");
  },
  beforeUnmount: function() {
    this._hook("onBeforeUnmount");
  },
  unmounted: function() {
    this._removeThemeListeners(), this._unloadScopedThemeStyles(), this._hook("onUnmounted");
  },
  methods: {
    _hook: function(t) {
      if (!this.$options.hostName) {
        var n = this._usePT(this._getPT(this.pt, this.$.type.name), this._getOptionValue, "hooks.".concat(t)), o = this._useDefaultPT(this._getOptionValue, "hooks.".concat(t));
        n?.(), o?.();
      }
    },
    _mergeProps: function(t) {
      for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
        o[r - 1] = arguments[r];
      return Tt(t) ? t.apply(void 0, o) : z.apply(void 0, o);
    },
    _load: function() {
      ge.isStyleNameLoaded("base") || (R.loadCSS(this.$styleOptions), this._loadGlobalStyles(), ge.setLoadedStyleName("base")), this._loadThemeStyles();
    },
    _loadStyles: function() {
      this._load(), this._themeChangeListener(this._load);
    },
    _loadCoreStyles: function() {
      var t, n;
      !ge.isStyleNameLoaded((t = this.$style) === null || t === void 0 ? void 0 : t.name) && (n = this.$style) !== null && n !== void 0 && n.name && (qt.loadCSS(this.$styleOptions), this.$options.style && this.$style.loadCSS(this.$styleOptions), ge.setLoadedStyleName(this.$style.name));
    },
    _loadGlobalStyles: function() {
      var t = this._useGlobalPT(this._getOptionValue, "global.css", this.$params);
      E(t) && R.load(t, P({
        name: "global"
      }, this.$styleOptions));
    },
    _loadThemeStyles: function() {
      var t, n;
      if (!(this.isUnstyled || this.$theme === "none")) {
        if (!I.isStyleNameLoaded("common")) {
          var o, r, l = ((o = this.$style) === null || o === void 0 || (r = o.getCommonTheme) === null || r === void 0 ? void 0 : r.call(o)) || {}, s = l.primitive, i = l.semantic, a = l.global, d = l.style;
          R.load(s?.css, P({
            name: "primitive-variables"
          }, this.$styleOptions)), R.load(i?.css, P({
            name: "semantic-variables"
          }, this.$styleOptions)), R.load(a?.css, P({
            name: "global-variables"
          }, this.$styleOptions)), R.loadStyle(P({
            name: "global-style"
          }, this.$styleOptions), d), I.setLoadedStyleName("common");
        }
        if (!I.isStyleNameLoaded((t = this.$style) === null || t === void 0 ? void 0 : t.name) && (n = this.$style) !== null && n !== void 0 && n.name) {
          var u, c, p, m, b = ((u = this.$style) === null || u === void 0 || (c = u.getComponentTheme) === null || c === void 0 ? void 0 : c.call(u)) || {}, v = b.css, g = b.style;
          (p = this.$style) === null || p === void 0 || p.load(v, P({
            name: "".concat(this.$style.name, "-variables")
          }, this.$styleOptions)), (m = this.$style) === null || m === void 0 || m.loadStyle(P({
            name: "".concat(this.$style.name, "-style")
          }, this.$styleOptions), g), I.setLoadedStyleName(this.$style.name);
        }
        if (!I.isStyleNameLoaded("layer-order")) {
          var $, S, O = ($ = this.$style) === null || $ === void 0 || (S = $.getLayerOrderThemeCSS) === null || S === void 0 ? void 0 : S.call($);
          R.load(O, P({
            name: "layer-order",
            first: !0
          }, this.$styleOptions)), I.setLoadedStyleName("layer-order");
        }
      }
    },
    _loadScopedThemeStyles: function(t) {
      var n, o, r, l = ((n = this.$style) === null || n === void 0 || (o = n.getPresetTheme) === null || o === void 0 ? void 0 : o.call(n, t, "[".concat(this.$attrSelector, "]"))) || {}, s = l.css, i = (r = this.$style) === null || r === void 0 ? void 0 : r.load(s, P({
        name: "".concat(this.$attrSelector, "-").concat(this.$style.name)
      }, this.$styleOptions));
      this.scopedStyleEl = i.el;
    },
    _unloadScopedThemeStyles: function() {
      var t;
      (t = this.scopedStyleEl) === null || t === void 0 || (t = t.value) === null || t === void 0 || t.remove();
    },
    _themeChangeListener: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
      };
      ge.clearLoadedStyleNames(), q.on("theme:change", t);
    },
    _removeThemeListeners: function() {
      q.off("theme:change", this._loadCoreStyles), q.off("theme:change", this._load), q.off("theme:change", this._themeScopedListener);
    },
    _getHostInstance: function(t) {
      return t ? this.$options.hostName ? t.$.type.name === this.$options.hostName ? t : this._getHostInstance(t.$parentInstance) : t.$parentInstance : void 0;
    },
    _getPropValue: function(t) {
      var n;
      return this[t] || ((n = this._getHostInstance(this)) === null || n === void 0 ? void 0 : n[t]);
    },
    _getOptionValue: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return jt(t, n, o);
    },
    _getPTValue: function() {
      var t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, s = /./g.test(o) && !!r[o.split(".")[0]], i = this._getPropValue("ptOptions") || ((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.ptOptions) || {}, a = i.mergeSections, d = a === void 0 ? !0 : a, u = i.mergeProps, c = u === void 0 ? !1 : u, p = l ? s ? this._useGlobalPT(this._getPTClassValue, o, r) : this._useDefaultPT(this._getPTClassValue, o, r) : void 0, m = s ? void 0 : this._getPTSelf(n, this._getPTClassValue, o, P(P({}, r), {}, {
        global: p || {}
      })), b = this._getPTDatasets(o);
      return d || !d && m ? c ? this._mergeProps(c, p, m, b) : P(P(P({}, p), m), b) : P(P({}, m), b);
    },
    _getPTSelf: function() {
      for (var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
        o[r - 1] = arguments[r];
      return z(
        this._usePT.apply(this, [this._getPT(t, this.$name)].concat(o)),
        // Exp; <component :pt="{}"
        this._usePT.apply(this, [this.$_attrsPT].concat(o))
        // Exp; <component :pt:[passthrough_key]:[attribute]="{value}" or <component :pt:[passthrough_key]="() =>{value}"
      );
    },
    _getPTDatasets: function() {
      var t, n, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", r = "data-pc-", l = o === "root" && E((t = this.pt) === null || t === void 0 ? void 0 : t["data-pc-section"]);
      return o !== "transition" && P(P({}, o === "root" && P(P(Ne({}, "".concat(r, "name"), se(l ? (n = this.pt) === null || n === void 0 ? void 0 : n["data-pc-section"] : this.$.type.name)), l && Ne({}, "".concat(r, "extend"), se(this.$.type.name))), {}, Ne({}, "".concat(this.$attrSelector), ""))), {}, Ne({}, "".concat(r, "section"), se(o)));
    },
    _getPTClassValue: function() {
      var t = this._getOptionValue.apply(this, arguments);
      return ee(t) || yn(t) ? {
        class: t
      } : t;
    },
    _getPT: function(t) {
      var n = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 ? arguments[2] : void 0, l = function(i) {
        var a, d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, u = r ? r(i) : i, c = se(o), p = se(n.$name);
        return (a = d ? c !== p ? u?.[c] : void 0 : u?.[c]) !== null && a !== void 0 ? a : u;
      };
      return t != null && t.hasOwnProperty("_usept") ? {
        _usept: t._usept,
        originalValue: l(t.originalValue),
        value: l(t.value)
      } : l(t, !0);
    },
    _usePT: function(t, n, o, r) {
      var l = function(v) {
        return n(v, o, r);
      };
      if (t != null && t.hasOwnProperty("_usept")) {
        var s, i = t._usept || ((s = this.$primevueConfig) === null || s === void 0 ? void 0 : s.ptOptions) || {}, a = i.mergeSections, d = a === void 0 ? !0 : a, u = i.mergeProps, c = u === void 0 ? !1 : u, p = l(t.originalValue), m = l(t.value);
        return p === void 0 && m === void 0 ? void 0 : ee(m) ? m : ee(p) ? p : d || !d && m ? c ? this._mergeProps(c, p, m) : P(P({}, p), m) : m;
      }
      return l(t);
    },
    _useGlobalPT: function(t, n, o) {
      return this._usePT(this.globalPT, t, n, o);
    },
    _useDefaultPT: function(t, n, o) {
      return this._usePT(this.defaultPT, t, n, o);
    },
    ptm: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this._getPTValue(this.pt, t, P(P({}, this.$params), n));
    },
    ptmi: function() {
      var t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = z(this.$_attrsWithoutPT, this.ptm(n, o));
      return r?.hasOwnProperty("id") && ((t = r.id) !== null && t !== void 0 || (r.id = this.$id)), r;
    },
    ptmo: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this._getPTValue(t, n, P({
        instance: this
      }, o), !1);
    },
    cx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.isUnstyled ? void 0 : this._getOptionValue(this.$style.classes, t, P(P({}, this.$params), n));
    },
    sx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (n) {
        var r = this._getOptionValue(this.$style.inlineStyles, t, P(P({}, this.$params), o)), l = this._getOptionValue(qt.inlineStyles, t, P(P({}, this.$params), o));
        return [l, r];
      }
    }
  },
  computed: {
    globalPT: function() {
      var t, n = this;
      return this._getPT((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.pt, void 0, function(o) {
        return ne(o, {
          instance: n
        });
      });
    },
    defaultPT: function() {
      var t, n = this;
      return this._getPT((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.pt, void 0, function(o) {
        return n._getOptionValue(o, n.$name, P({}, n.$params)) || ne(o, P({}, n.$params));
      });
    },
    isUnstyled: function() {
      var t;
      return this.unstyled !== void 0 ? this.unstyled : (t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.unstyled;
    },
    $id: function() {
      return this.$attrs.id || this.uid;
    },
    $inProps: function() {
      var t, n = Object.keys(((t = this.$.vnode) === null || t === void 0 ? void 0 : t.props) || {});
      return Object.fromEntries(Object.entries(this.$props).filter(function(o) {
        var r = je(o, 1), l = r[0];
        return n?.includes(l);
      }));
    },
    $theme: function() {
      var t;
      return (t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.theme;
    },
    $style: function() {
      return P(P({
        classes: void 0,
        inlineStyles: void 0,
        load: function() {
        },
        loadCSS: function() {
        },
        loadStyle: function() {
        }
      }, (this._getHostInstance(this) || {}).$style), this.$options.style);
    },
    $styleOptions: function() {
      var t;
      return {
        nonce: (t = this.$primevueConfig) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce
      };
    },
    $primevueConfig: function() {
      var t;
      return (t = this.$primevue) === null || t === void 0 ? void 0 : t.config;
    },
    $name: function() {
      return this.$options.hostName || this.$.type.name;
    },
    $params: function() {
      var t = this._getHostInstance(this) || this.$parent;
      return {
        instance: this,
        props: this.$props,
        state: this.$data,
        attrs: this.$attrs,
        parent: {
          instance: t,
          props: t?.$props,
          state: t?.$data,
          attrs: t?.$attrs
        }
      };
    },
    $_attrsPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(t) {
        var n = je(t, 1), o = n[0];
        return o?.startsWith("pt:");
      }).reduce(function(t, n) {
        var o = je(n, 2), r = o[0], l = o[1], s = r.split(":"), i = Jo(s), a = St(i).slice(1);
        return a?.reduce(function(d, u, c, p) {
          return !d[u] && (d[u] = c === p.length - 1 ? l : {}), d[u];
        }, t), t;
      }, {});
    },
    $_attrsWithoutPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(t) {
        var n = je(t, 1), o = n[0];
        return !(o != null && o.startsWith("pt:"));
      }).reduce(function(t, n) {
        var o = je(n, 2), r = o[0], l = o[1];
        return t[r] = l, t;
      }, {});
    }
  }
}, rr = {
  name: "BaseEditableHolder",
  extends: Ge,
  emits: ["update:modelValue", "value-change"],
  props: {
    modelValue: {
      type: null,
      default: void 0
    },
    defaultValue: {
      type: null,
      default: void 0
    },
    name: {
      type: String,
      default: void 0
    },
    invalid: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    formControl: {
      type: Object,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    },
    $pcForm: {
      default: void 0
    },
    $pcFormField: {
      default: void 0
    }
  },
  data: function() {
    return {
      d_value: this.defaultValue !== void 0 ? this.defaultValue : this.modelValue
    };
  },
  watch: {
    modelValue: {
      deep: !0,
      handler: function(t) {
        this.d_value = t;
      }
    },
    defaultValue: function(t) {
      this.d_value = t;
    },
    $formName: {
      immediate: !0,
      handler: function(t) {
        var n, o;
        this.formField = ((n = this.$pcForm) === null || n === void 0 || (o = n.register) === null || o === void 0 ? void 0 : o.call(n, t, this.$formControl)) || {};
      }
    },
    $formControl: {
      immediate: !0,
      handler: function(t) {
        var n, o;
        this.formField = ((n = this.$pcForm) === null || n === void 0 || (o = n.register) === null || o === void 0 ? void 0 : o.call(n, this.$formName, t)) || {};
      }
    },
    $formDefaultValue: {
      immediate: !0,
      handler: function(t) {
        this.d_value !== t && (this.d_value = t);
      }
    },
    $formValue: {
      immediate: !1,
      handler: function(t) {
        var n;
        (n = this.$pcForm) !== null && n !== void 0 && n.getFieldState(this.$formName) && t !== this.d_value && (this.d_value = t);
      }
    }
  },
  formField: {},
  methods: {
    writeValue: function(t, n) {
      var o, r;
      this.controlled && (this.d_value = t, this.$emit("update:modelValue", t)), this.$emit("value-change", t), (o = (r = this.formField).onChange) === null || o === void 0 || o.call(r, {
        originalEvent: n,
        value: t
      });
    },
    // @todo move to @primeuix/utils
    findNonEmpty: function() {
      for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
        n[o] = arguments[o];
      return n.find(E);
    }
  },
  computed: {
    $filled: function() {
      return E(this.d_value);
    },
    $invalid: function() {
      var t, n;
      return !this.$formNovalidate && this.findNonEmpty(this.invalid, (t = this.$pcFormField) === null || t === void 0 || (t = t.$field) === null || t === void 0 ? void 0 : t.invalid, (n = this.$pcForm) === null || n === void 0 || (n = n.getFieldState(this.$formName)) === null || n === void 0 ? void 0 : n.invalid);
    },
    $formName: function() {
      var t;
      return this.$formNovalidate ? void 0 : this.name || ((t = this.$formControl) === null || t === void 0 ? void 0 : t.name);
    },
    $formControl: function() {
      var t;
      return this.formControl || ((t = this.$pcFormField) === null || t === void 0 ? void 0 : t.formControl);
    },
    $formNovalidate: function() {
      var t;
      return (t = this.$formControl) === null || t === void 0 ? void 0 : t.novalidate;
    },
    $formDefaultValue: function() {
      var t, n;
      return this.findNonEmpty(this.d_value, (t = this.$pcFormField) === null || t === void 0 ? void 0 : t.initialValue, (n = this.$pcForm) === null || n === void 0 || (n = n.initialValues) === null || n === void 0 ? void 0 : n[this.$formName]);
    },
    $formValue: function() {
      var t, n;
      return this.findNonEmpty((t = this.$pcFormField) === null || t === void 0 || (t = t.$field) === null || t === void 0 ? void 0 : t.value, (n = this.$pcForm) === null || n === void 0 || (n = n.getFieldState(this.$formName)) === null || n === void 0 ? void 0 : n.value);
    },
    controlled: function() {
      return this.$inProps.hasOwnProperty("modelValue") || !this.$inProps.hasOwnProperty("modelValue") && !this.$inProps.hasOwnProperty("defaultValue");
    },
    // @deprecated use $filled instead
    filled: function() {
      return this.$filled;
    }
  }
}, ar = {
  name: "BaseInput",
  extends: rr,
  props: {
    size: {
      type: String,
      default: null
    },
    fluid: {
      type: Boolean,
      default: null
    },
    variant: {
      type: String,
      default: null
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    },
    $pcFluid: {
      default: void 0
    }
  },
  computed: {
    $variant: function() {
      var t;
      return (t = this.variant) !== null && t !== void 0 ? t : this.$primevue.config.inputStyle || this.$primevue.config.inputVariant;
    },
    $fluid: function() {
      var t;
      return (t = this.fluid) !== null && t !== void 0 ? t : !!this.$pcFluid;
    },
    // @deprecated use $fluid instead
    hasFluid: function() {
      return this.$fluid;
    }
  }
}, ir = `
    .p-inputtext {
        font-family: inherit;
        font-feature-settings: inherit;
        font-size: 1rem;
        color: dt('inputtext.color');
        background: dt('inputtext.background');
        padding-block: dt('inputtext.padding.y');
        padding-inline: dt('inputtext.padding.x');
        border: 1px solid dt('inputtext.border.color');
        transition:
            background dt('inputtext.transition.duration'),
            color dt('inputtext.transition.duration'),
            border-color dt('inputtext.transition.duration'),
            outline-color dt('inputtext.transition.duration'),
            box-shadow dt('inputtext.transition.duration');
        appearance: none;
        border-radius: dt('inputtext.border.radius');
        outline-color: transparent;
        box-shadow: dt('inputtext.shadow');
    }

    .p-inputtext:enabled:hover {
        border-color: dt('inputtext.hover.border.color');
    }

    .p-inputtext:enabled:focus {
        border-color: dt('inputtext.focus.border.color');
        box-shadow: dt('inputtext.focus.ring.shadow');
        outline: dt('inputtext.focus.ring.width') dt('inputtext.focus.ring.style') dt('inputtext.focus.ring.color');
        outline-offset: dt('inputtext.focus.ring.offset');
    }

    .p-inputtext.p-invalid {
        border-color: dt('inputtext.invalid.border.color');
    }

    .p-inputtext.p-variant-filled {
        background: dt('inputtext.filled.background');
    }

    .p-inputtext.p-variant-filled:enabled:hover {
        background: dt('inputtext.filled.hover.background');
    }

    .p-inputtext.p-variant-filled:enabled:focus {
        background: dt('inputtext.filled.focus.background');
    }

    .p-inputtext:disabled {
        opacity: 1;
        background: dt('inputtext.disabled.background');
        color: dt('inputtext.disabled.color');
    }

    .p-inputtext::placeholder {
        color: dt('inputtext.placeholder.color');
    }

    .p-inputtext.p-invalid::placeholder {
        color: dt('inputtext.invalid.placeholder.color');
    }

    .p-inputtext-sm {
        font-size: dt('inputtext.sm.font.size');
        padding-block: dt('inputtext.sm.padding.y');
        padding-inline: dt('inputtext.sm.padding.x');
    }

    .p-inputtext-lg {
        font-size: dt('inputtext.lg.font.size');
        padding-block: dt('inputtext.lg.padding.y');
        padding-inline: dt('inputtext.lg.padding.x');
    }

    .p-inputtext-fluid {
        width: 100%;
    }
`, lr = {
  root: function(t) {
    var n = t.instance, o = t.props;
    return ["p-inputtext p-component", {
      "p-filled": n.$filled,
      "p-inputtext-sm p-inputfield-sm": o.size === "small",
      "p-inputtext-lg p-inputfield-lg": o.size === "large",
      "p-invalid": n.$invalid,
      "p-variant-filled": n.$variant === "filled",
      "p-inputtext-fluid": n.$fluid
    }];
  }
}, sr = R.extend({
  name: "inputtext",
  style: ir,
  classes: lr
}), dr = {
  name: "BaseInputText",
  extends: ar,
  style: sr,
  provide: function() {
    return {
      $pcInputText: this,
      $parentInstance: this
    };
  }
};
function De(e) {
  "@babel/helpers - typeof";
  return De = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, De(e);
}
function ur(e, t, n) {
  return (t = cr(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function cr(e) {
  var t = pr(e, "string");
  return De(t) == "symbol" ? t : t + "";
}
function pr(e, t) {
  if (De(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (De(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var xe = {
  name: "InputText",
  extends: dr,
  inheritAttrs: !1,
  methods: {
    onInput: function(t) {
      this.writeValue(t.target.value, t);
    }
  },
  computed: {
    attrs: function() {
      return z(this.ptmi("root", {
        context: {
          filled: this.$filled,
          disabled: this.disabled
        }
      }), this.formField);
    },
    dataP: function() {
      return ye(ur({
        invalid: this.$invalid,
        fluid: this.$fluid,
        filled: this.$variant === "filled"
      }, this.size, this.size));
    }
  }
}, mr = ["value", "name", "disabled", "aria-invalid", "data-p"];
function fr(e, t, n, o, r, l) {
  return k(), C("input", z({
    type: "text",
    class: e.cx("root"),
    value: e.d_value,
    name: e.name,
    disabled: e.disabled,
    "aria-invalid": e.$invalid || void 0,
    "data-p": l.dataP,
    onInput: t[0] || (t[0] = function() {
      return l.onInput && l.onInput.apply(l, arguments);
    })
  }, l.attrs), null, 16, mr);
}
xe.render = fr;
var br = `
.p-icon {
    display: inline-block;
    vertical-align: baseline;
    flex-shrink: 0;
}

.p-icon-spin {
    -webkit-animation: p-icon-spin 2s infinite linear;
    animation: p-icon-spin 2s infinite linear;
}

@-webkit-keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
`, gr = R.extend({
  name: "baseicon",
  css: br
});
function Be(e) {
  "@babel/helpers - typeof";
  return Be = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Be(e);
}
function Qt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Jt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qt(Object(n), !0).forEach(function(o) {
      vr(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Qt(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function vr(e, t, n) {
  return (t = hr(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function hr(e) {
  var t = yr(e, "string");
  return Be(t) == "symbol" ? t : t + "";
}
function yr(e, t) {
  if (Be(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Be(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Nn = {
  name: "BaseIcon",
  extends: Ge,
  props: {
    label: {
      type: String,
      default: void 0
    },
    spin: {
      type: Boolean,
      default: !1
    }
  },
  style: gr,
  provide: function() {
    return {
      $pcIcon: this,
      $parentInstance: this
    };
  },
  methods: {
    pti: function() {
      var t = Se(this.label);
      return Jt(Jt({}, !this.isUnstyled && {
        class: ["p-icon", {
          "p-icon-spin": this.spin
        }]
      }), {}, {
        role: t ? void 0 : "img",
        "aria-label": t ? void 0 : this.label,
        "aria-hidden": t
      });
    }
  }
}, Ln = {
  name: "SpinnerIcon",
  extends: Nn
};
function $r(e) {
  return wr(e) || Sr(e) || kr(e) || _r();
}
function _r() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kr(e, t) {
  if (e) {
    if (typeof e == "string") return wt(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? wt(e, t) : void 0;
  }
}
function Sr(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function wr(e) {
  if (Array.isArray(e)) return wt(e);
}
function wt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Pr(e, t, n, o, r, l) {
  return k(), C("svg", z({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), $r(t[0] || (t[0] = [V("path", {
    d: "M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
Ln.render = Pr;
var xr = `
    .p-badge {
        display: inline-flex;
        border-radius: dt('badge.border.radius');
        align-items: center;
        justify-content: center;
        padding: dt('badge.padding');
        background: dt('badge.primary.background');
        color: dt('badge.primary.color');
        font-size: dt('badge.font.size');
        font-weight: dt('badge.font.weight');
        min-width: dt('badge.min.width');
        height: dt('badge.height');
    }

    .p-badge-dot {
        width: dt('badge.dot.size');
        min-width: dt('badge.dot.size');
        height: dt('badge.dot.size');
        border-radius: 50%;
        padding: 0;
    }

    .p-badge-circle {
        padding: 0;
        border-radius: 50%;
    }

    .p-badge-secondary {
        background: dt('badge.secondary.background');
        color: dt('badge.secondary.color');
    }

    .p-badge-success {
        background: dt('badge.success.background');
        color: dt('badge.success.color');
    }

    .p-badge-info {
        background: dt('badge.info.background');
        color: dt('badge.info.color');
    }

    .p-badge-warn {
        background: dt('badge.warn.background');
        color: dt('badge.warn.color');
    }

    .p-badge-danger {
        background: dt('badge.danger.background');
        color: dt('badge.danger.color');
    }

    .p-badge-contrast {
        background: dt('badge.contrast.background');
        color: dt('badge.contrast.color');
    }

    .p-badge-sm {
        font-size: dt('badge.sm.font.size');
        min-width: dt('badge.sm.min.width');
        height: dt('badge.sm.height');
    }

    .p-badge-lg {
        font-size: dt('badge.lg.font.size');
        min-width: dt('badge.lg.min.width');
        height: dt('badge.lg.height');
    }

    .p-badge-xl {
        font-size: dt('badge.xl.font.size');
        min-width: dt('badge.xl.min.width');
        height: dt('badge.xl.height');
    }
`, Cr = {
  root: function(t) {
    var n = t.props, o = t.instance;
    return ["p-badge p-component", {
      "p-badge-circle": E(n.value) && String(n.value).length === 1,
      "p-badge-dot": Se(n.value) && !o.$slots.default,
      "p-badge-sm": n.size === "small",
      "p-badge-lg": n.size === "large",
      "p-badge-xl": n.size === "xlarge",
      "p-badge-info": n.severity === "info",
      "p-badge-success": n.severity === "success",
      "p-badge-warn": n.severity === "warn",
      "p-badge-danger": n.severity === "danger",
      "p-badge-secondary": n.severity === "secondary",
      "p-badge-contrast": n.severity === "contrast"
    }];
  }
}, Or = R.extend({
  name: "badge",
  style: xr,
  classes: Cr
}), Tr = {
  name: "BaseBadge",
  extends: Ge,
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    severity: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  style: Or,
  provide: function() {
    return {
      $pcBadge: this,
      $parentInstance: this
    };
  }
};
function Fe(e) {
  "@babel/helpers - typeof";
  return Fe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fe(e);
}
function en(e, t, n) {
  return (t = jr(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function jr(e) {
  var t = Nr(e, "string");
  return Fe(t) == "symbol" ? t : t + "";
}
function Nr(e, t) {
  if (Fe(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Fe(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var En = {
  name: "Badge",
  extends: Tr,
  inheritAttrs: !1,
  computed: {
    dataP: function() {
      return ye(en(en({
        circle: this.value != null && String(this.value).length === 1,
        empty: this.value == null && !this.$slots.default
      }, this.severity, this.severity), this.size, this.size));
    }
  }
}, Lr = ["data-p"];
function Er(e, t, n, o, r, l) {
  return k(), C("span", z({
    class: e.cx("root"),
    "data-p": l.dataP
  }, e.ptmi("root")), [pe(e.$slots, "default", {}, function() {
    return [tt(Y(e.value), 1)];
  })], 16, Lr);
}
En.render = Er;
var Je = hn();
function Me(e) {
  "@babel/helpers - typeof";
  return Me = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Me(e);
}
function tn(e, t) {
  return Vr(e) || Ir(e, t) || Ar(e, t) || zr();
}
function zr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ar(e, t) {
  if (e) {
    if (typeof e == "string") return nn(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? nn(e, t) : void 0;
  }
}
function nn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Ir(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o, r, l, s, i = [], a = !0, d = !1;
    try {
      if (l = (n = n.call(e)).next, t !== 0) for (; !(a = (o = l.call(n)).done) && (i.push(o.value), i.length !== t); a = !0) ;
    } catch (u) {
      d = !0, r = u;
    } finally {
      try {
        if (!a && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (d) throw r;
      }
    }
    return i;
  }
}
function Vr(e) {
  if (Array.isArray(e)) return e;
}
function on(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function j(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? on(Object(n), !0).forEach(function(o) {
      Pt(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : on(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Pt(e, t, n) {
  return (t = Dr(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Dr(e) {
  var t = Br(e, "string");
  return Me(t) == "symbol" ? t : t + "";
}
function Br(e, t) {
  if (Me(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Me(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var w = {
  _getMeta: function() {
    return [ve(arguments.length <= 0 ? void 0 : arguments[0]) || arguments.length <= 0 ? void 0 : arguments[0], ne(ve(arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 0 ? void 0 : arguments[0] : arguments.length <= 1 ? void 0 : arguments[1])];
  },
  _getConfig: function(t, n) {
    var o, r, l;
    return (o = (t == null || (r = t.instance) === null || r === void 0 ? void 0 : r.$primevue) || (n == null || (l = n.ctx) === null || l === void 0 || (l = l.appContext) === null || l === void 0 || (l = l.config) === null || l === void 0 || (l = l.globalProperties) === null || l === void 0 ? void 0 : l.$primevue)) === null || o === void 0 ? void 0 : o.config;
  },
  _getOptionValue: jt,
  _getPTValue: function() {
    var t, n, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, a = function() {
      var S = w._getOptionValue.apply(w, arguments);
      return ee(S) || yn(S) ? {
        class: S
      } : S;
    }, d = ((t = o.binding) === null || t === void 0 || (t = t.value) === null || t === void 0 ? void 0 : t.ptOptions) || ((n = o.$primevueConfig) === null || n === void 0 ? void 0 : n.ptOptions) || {}, u = d.mergeSections, c = u === void 0 ? !0 : u, p = d.mergeProps, m = p === void 0 ? !1 : p, b = i ? w._useDefaultPT(o, o.defaultPT(), a, l, s) : void 0, v = w._usePT(o, w._getPT(r, o.$name), a, l, j(j({}, s), {}, {
      global: b || {}
    })), g = w._getPTDatasets(o, l);
    return c || !c && v ? m ? w._mergeProps(o, m, b, v, g) : j(j(j({}, b), v), g) : j(j({}, v), g);
  },
  _getPTDatasets: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = "data-pc-";
    return j(j({}, n === "root" && Pt({}, "".concat(o, "name"), se(t.$name))), {}, Pt({}, "".concat(o, "section"), se(n)));
  },
  _getPT: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 ? arguments[2] : void 0, r = function(s) {
      var i, a = o ? o(s) : s, d = se(n);
      return (i = a?.[d]) !== null && i !== void 0 ? i : a;
    };
    return t && Object.hasOwn(t, "_usept") ? {
      _usept: t._usept,
      originalValue: r(t.originalValue),
      value: r(t.value)
    } : r(t);
  },
  _usePT: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0, o = arguments.length > 2 ? arguments[2] : void 0, r = arguments.length > 3 ? arguments[3] : void 0, l = arguments.length > 4 ? arguments[4] : void 0, s = function(g) {
      return o(g, r, l);
    };
    if (n && Object.hasOwn(n, "_usept")) {
      var i, a = n._usept || ((i = t.$primevueConfig) === null || i === void 0 ? void 0 : i.ptOptions) || {}, d = a.mergeSections, u = d === void 0 ? !0 : d, c = a.mergeProps, p = c === void 0 ? !1 : c, m = s(n.originalValue), b = s(n.value);
      return m === void 0 && b === void 0 ? void 0 : ee(b) ? b : ee(m) ? m : u || !u && b ? p ? w._mergeProps(t, p, m, b) : j(j({}, m), b) : b;
    }
    return s(n);
  },
  _useDefaultPT: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 ? arguments[2] : void 0, r = arguments.length > 3 ? arguments[3] : void 0, l = arguments.length > 4 ? arguments[4] : void 0;
    return w._usePT(t, n, o, r, l);
  },
  _loadStyles: function() {
    var t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0, l = w._getConfig(o, r), s = {
      nonce: l == null || (t = l.csp) === null || t === void 0 ? void 0 : t.nonce
    };
    w._loadCoreStyles(n, s), w._loadThemeStyles(n, s), w._loadScopedThemeStyles(n, s), w._removeThemeListeners(n), n.$loadStyles = function() {
      return w._loadThemeStyles(n, s);
    }, w._themeChangeListener(n.$loadStyles);
  },
  _loadCoreStyles: function() {
    var t, n, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    if (!ge.isStyleNameLoaded((t = o.$style) === null || t === void 0 ? void 0 : t.name) && (n = o.$style) !== null && n !== void 0 && n.name) {
      var l;
      R.loadCSS(r), (l = o.$style) === null || l === void 0 || l.loadCSS(r), ge.setLoadedStyleName(o.$style.name);
    }
  },
  _loadThemeStyles: function() {
    var t, n, o, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = arguments.length > 1 ? arguments[1] : void 0;
    if (!(r != null && r.isUnstyled() || (r == null || (t = r.theme) === null || t === void 0 ? void 0 : t.call(r)) === "none")) {
      if (!I.isStyleNameLoaded("common")) {
        var s, i, a = ((s = r.$style) === null || s === void 0 || (i = s.getCommonTheme) === null || i === void 0 ? void 0 : i.call(s)) || {}, d = a.primitive, u = a.semantic, c = a.global, p = a.style;
        R.load(d?.css, j({
          name: "primitive-variables"
        }, l)), R.load(u?.css, j({
          name: "semantic-variables"
        }, l)), R.load(c?.css, j({
          name: "global-variables"
        }, l)), R.loadStyle(j({
          name: "global-style"
        }, l), p), I.setLoadedStyleName("common");
      }
      if (!I.isStyleNameLoaded((n = r.$style) === null || n === void 0 ? void 0 : n.name) && (o = r.$style) !== null && o !== void 0 && o.name) {
        var m, b, v, g, $ = ((m = r.$style) === null || m === void 0 || (b = m.getDirectiveTheme) === null || b === void 0 ? void 0 : b.call(m)) || {}, S = $.css, O = $.style;
        (v = r.$style) === null || v === void 0 || v.load(S, j({
          name: "".concat(r.$style.name, "-variables")
        }, l)), (g = r.$style) === null || g === void 0 || g.loadStyle(j({
          name: "".concat(r.$style.name, "-style")
        }, l), O), I.setLoadedStyleName(r.$style.name);
      }
      if (!I.isStyleNameLoaded("layer-order")) {
        var f, y, _ = (f = r.$style) === null || f === void 0 || (y = f.getLayerOrderThemeCSS) === null || y === void 0 ? void 0 : y.call(f);
        R.load(_, j({
          name: "layer-order",
          first: !0
        }, l)), I.setLoadedStyleName("layer-order");
      }
    }
  },
  _loadScopedThemeStyles: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0, o = t.preset();
    if (o && t.$attrSelector) {
      var r, l, s, i = ((r = t.$style) === null || r === void 0 || (l = r.getPresetTheme) === null || l === void 0 ? void 0 : l.call(r, o, "[".concat(t.$attrSelector, "]"))) || {}, a = i.css, d = (s = t.$style) === null || s === void 0 ? void 0 : s.load(a, j({
        name: "".concat(t.$attrSelector, "-").concat(t.$style.name)
      }, n));
      t.scopedStyleEl = d.el;
    }
  },
  _themeChangeListener: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
    };
    ge.clearLoadedStyleNames(), q.on("theme:change", t);
  },
  _removeThemeListeners: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    q.off("theme:change", t.$loadStyles), t.$loadStyles = void 0;
  },
  _hook: function(t, n, o, r, l, s) {
    var i, a, d = "on".concat(So(n)), u = w._getConfig(r, l), c = o?.$instance, p = w._usePT(c, w._getPT(r == null || (i = r.value) === null || i === void 0 ? void 0 : i.pt, t), w._getOptionValue, "hooks.".concat(d)), m = w._useDefaultPT(c, u == null || (a = u.pt) === null || a === void 0 || (a = a.directives) === null || a === void 0 ? void 0 : a[t], w._getOptionValue, "hooks.".concat(d)), b = {
      el: o,
      binding: r,
      vnode: l,
      prevVnode: s
    };
    p?.(c, b), m?.(c, b);
  },
  /* eslint-disable-next-line no-unused-vars */
  _mergeProps: function() {
    for (var t = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)
      o[r - 2] = arguments[r];
    return Tt(t) ? t.apply(void 0, o) : z.apply(void 0, o);
  },
  _extend: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = function(i, a, d, u, c) {
      var p, m, b, v;
      a._$instances = a._$instances || {};
      var g = w._getConfig(d, u), $ = a._$instances[t] || {}, S = Se($) ? j(j({}, n), n?.methods) : {};
      a._$instances[t] = j(j({}, $), {}, {
        /* new instance variables to pass in directive methods */
        $name: t,
        $host: a,
        $binding: d,
        $modifiers: d?.modifiers,
        $value: d?.value,
        $el: $.$el || a || void 0,
        $style: j({
          classes: void 0,
          inlineStyles: void 0,
          load: function() {
          },
          loadCSS: function() {
          },
          loadStyle: function() {
          }
        }, n?.style),
        $primevueConfig: g,
        $attrSelector: (p = a.$pd) === null || p === void 0 || (p = p[t]) === null || p === void 0 ? void 0 : p.attrSelector,
        /* computed instance variables */
        defaultPT: function() {
          return w._getPT(g?.pt, void 0, function(f) {
            var y;
            return f == null || (y = f.directives) === null || y === void 0 ? void 0 : y[t];
          });
        },
        isUnstyled: function() {
          var f, y;
          return ((f = a._$instances[t]) === null || f === void 0 || (f = f.$binding) === null || f === void 0 || (f = f.value) === null || f === void 0 ? void 0 : f.unstyled) !== void 0 ? (y = a._$instances[t]) === null || y === void 0 || (y = y.$binding) === null || y === void 0 || (y = y.value) === null || y === void 0 ? void 0 : y.unstyled : g?.unstyled;
        },
        theme: function() {
          var f;
          return (f = a._$instances[t]) === null || f === void 0 || (f = f.$primevueConfig) === null || f === void 0 ? void 0 : f.theme;
        },
        preset: function() {
          var f;
          return (f = a._$instances[t]) === null || f === void 0 || (f = f.$binding) === null || f === void 0 || (f = f.value) === null || f === void 0 ? void 0 : f.dt;
        },
        /* instance's methods */
        ptm: function() {
          var f, y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return w._getPTValue(a._$instances[t], (f = a._$instances[t]) === null || f === void 0 || (f = f.$binding) === null || f === void 0 || (f = f.value) === null || f === void 0 ? void 0 : f.pt, y, j({}, _));
        },
        ptmo: function() {
          var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return w._getPTValue(a._$instances[t], f, y, _, !1);
        },
        cx: function() {
          var f, y, _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return (f = a._$instances[t]) !== null && f !== void 0 && f.isUnstyled() ? void 0 : w._getOptionValue((y = a._$instances[t]) === null || y === void 0 || (y = y.$style) === null || y === void 0 ? void 0 : y.classes, _, j({}, x));
        },
        sx: function() {
          var f, y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return _ ? w._getOptionValue((f = a._$instances[t]) === null || f === void 0 || (f = f.$style) === null || f === void 0 ? void 0 : f.inlineStyles, y, j({}, x)) : void 0;
        }
      }, S), a.$instance = a._$instances[t], (m = (b = a.$instance)[i]) === null || m === void 0 || m.call(b, a, d, u, c), a["$".concat(t)] = a.$instance, w._hook(t, i, a, d, u, c), a.$pd || (a.$pd = {}), a.$pd[t] = j(j({}, (v = a.$pd) === null || v === void 0 ? void 0 : v[t]), {}, {
        name: t,
        instance: a._$instances[t]
      });
    }, r = function(i) {
      var a, d, u, c = i._$instances[t], p = c?.watch, m = function(g) {
        var $, S = g.newValue, O = g.oldValue;
        return p == null || ($ = p.config) === null || $ === void 0 ? void 0 : $.call(c, S, O);
      }, b = function(g) {
        var $, S = g.newValue, O = g.oldValue;
        return p == null || ($ = p["config.ripple"]) === null || $ === void 0 ? void 0 : $.call(c, S, O);
      };
      c.$watchersCallback = {
        config: m,
        "config.ripple": b
      }, p == null || (a = p.config) === null || a === void 0 || a.call(c, c?.$primevueConfig), Je.on("config:change", m), p == null || (d = p["config.ripple"]) === null || d === void 0 || d.call(c, c == null || (u = c.$primevueConfig) === null || u === void 0 ? void 0 : u.ripple), Je.on("config:ripple:change", b);
    }, l = function(i) {
      var a = i._$instances[t].$watchersCallback;
      a && (Je.off("config:change", a.config), Je.off("config:ripple:change", a["config.ripple"]), i._$instances[t].$watchersCallback = void 0);
    };
    return {
      created: function(i, a, d, u) {
        i.$pd || (i.$pd = {}), i.$pd[t] = {
          name: t,
          attrSelector: wo("pd")
        }, o("created", i, a, d, u);
      },
      beforeMount: function(i, a, d, u) {
        var c;
        w._loadStyles((c = i.$pd[t]) === null || c === void 0 ? void 0 : c.instance, a, d), o("beforeMount", i, a, d, u), r(i);
      },
      mounted: function(i, a, d, u) {
        var c;
        w._loadStyles((c = i.$pd[t]) === null || c === void 0 ? void 0 : c.instance, a, d), o("mounted", i, a, d, u);
      },
      beforeUpdate: function(i, a, d, u) {
        o("beforeUpdate", i, a, d, u);
      },
      updated: function(i, a, d, u) {
        var c;
        w._loadStyles((c = i.$pd[t]) === null || c === void 0 ? void 0 : c.instance, a, d), o("updated", i, a, d, u);
      },
      beforeUnmount: function(i, a, d, u) {
        var c;
        l(i), w._removeThemeListeners((c = i.$pd[t]) === null || c === void 0 ? void 0 : c.instance), o("beforeUnmount", i, a, d, u);
      },
      unmounted: function(i, a, d, u) {
        var c;
        (c = i.$pd[t]) === null || c === void 0 || (c = c.instance) === null || c === void 0 || (c = c.scopedStyleEl) === null || c === void 0 || (c = c.value) === null || c === void 0 || c.remove(), o("unmounted", i, a, d, u);
      }
    };
  },
  extend: function() {
    var t = w._getMeta.apply(w, arguments), n = tn(t, 2), o = n[0], r = n[1];
    return j({
      extend: function() {
        var s = w._getMeta.apply(w, arguments), i = tn(s, 2), a = i[0], d = i[1];
        return w.extend(a, j(j(j({}, r), r?.methods), d));
      }
    }, w._extend(o, r));
  }
}, Fr = `
    .p-ink {
        display: block;
        position: absolute;
        background: dt('ripple.background');
        border-radius: 100%;
        transform: scale(0);
        pointer-events: none;
    }

    .p-ink-active {
        animation: ripple 0.4s linear;
    }

    @keyframes ripple {
        100% {
            opacity: 0;
            transform: scale(2.5);
        }
    }
`, Mr = {
  root: "p-ink"
}, Ur = R.extend({
  name: "ripple-directive",
  style: Fr,
  classes: Mr
}), Rr = w.extend({
  style: Ur
});
function Ue(e) {
  "@babel/helpers - typeof";
  return Ue = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ue(e);
}
function Kr(e) {
  return Gr(e) || Yr(e) || Hr(e) || Wr();
}
function Wr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hr(e, t) {
  if (e) {
    if (typeof e == "string") return xt(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? xt(e, t) : void 0;
  }
}
function Yr(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Gr(e) {
  if (Array.isArray(e)) return xt(e);
}
function xt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function rn(e, t, n) {
  return (t = Zr(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Zr(e) {
  var t = qr(e, "string");
  return Ue(t) == "symbol" ? t : t + "";
}
function qr(e, t) {
  if (Ue(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Ue(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zn = Rr.extend("ripple", {
  watch: {
    "config.ripple": function(t) {
      t ? (this.createRipple(this.$host), this.bindEvents(this.$host), this.$host.setAttribute("data-pd-ripple", !0), this.$host.style.overflow = "hidden", this.$host.style.position = "relative") : (this.remove(this.$host), this.$host.removeAttribute("data-pd-ripple"));
    }
  },
  unmounted: function(t) {
    this.remove(t);
  },
  timeout: void 0,
  methods: {
    bindEvents: function(t) {
      t.addEventListener("mousedown", this.onMouseDown.bind(this));
    },
    unbindEvents: function(t) {
      t.removeEventListener("mousedown", this.onMouseDown.bind(this));
    },
    createRipple: function(t) {
      var n = this.getInk(t);
      n || (n = bo("span", rn(rn({
        role: "presentation",
        "aria-hidden": !0,
        "data-p-ink": !0,
        "data-p-ink-active": !1,
        class: !this.isUnstyled() && this.cx("root"),
        onAnimationEnd: this.onAnimationEnd.bind(this)
      }, this.$attrSelector, ""), "p-bind", this.ptm("root"))), t.appendChild(n), this.$el = n);
    },
    remove: function(t) {
      var n = this.getInk(t);
      n && (this.$host.style.overflow = "", this.$host.style.position = "", this.unbindEvents(t), n.removeEventListener("animationend", this.onAnimationEnd), n.remove());
    },
    onMouseDown: function(t) {
      var n = this, o = t.currentTarget, r = this.getInk(o);
      if (!(!r || getComputedStyle(r, null).display === "none")) {
        if (!this.isUnstyled() && vt(r, "p-ink-active"), r.setAttribute("data-p-ink-active", "false"), !Vt(r) && !Dt(r)) {
          var l = Math.max(po(o), yo(o));
          r.style.height = l + "px", r.style.width = l + "px";
        }
        var s = ho(o), i = t.pageX - s.left + document.body.scrollTop - Dt(r) / 2, a = t.pageY - s.top + document.body.scrollLeft - Vt(r) / 2;
        r.style.top = a + "px", r.style.left = i + "px", !this.isUnstyled() && co(r, "p-ink-active"), r.setAttribute("data-p-ink-active", "true"), this.timeout = setTimeout(function() {
          r && (!n.isUnstyled() && vt(r, "p-ink-active"), r.setAttribute("data-p-ink-active", "false"));
        }, 401);
      }
    },
    onAnimationEnd: function(t) {
      this.timeout && clearTimeout(this.timeout), !this.isUnstyled() && vt(t.currentTarget, "p-ink-active"), t.currentTarget.setAttribute("data-p-ink-active", "false");
    },
    getInk: function(t) {
      return t && t.children ? Kr(t.children).find(function(n) {
        return vo(n, "data-pc-name") === "ripple";
      }) : void 0;
    }
  }
}), Xr = `
    .p-button {
        display: inline-flex;
        cursor: pointer;
        user-select: none;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
        color: dt('button.primary.color');
        background: dt('button.primary.background');
        border: 1px solid dt('button.primary.border.color');
        padding: dt('button.padding.y') dt('button.padding.x');
        font-size: 1rem;
        font-family: inherit;
        font-feature-settings: inherit;
        transition:
            background dt('button.transition.duration'),
            color dt('button.transition.duration'),
            border-color dt('button.transition.duration'),
            outline-color dt('button.transition.duration'),
            box-shadow dt('button.transition.duration');
        border-radius: dt('button.border.radius');
        outline-color: transparent;
        gap: dt('button.gap');
    }

    .p-button:disabled {
        cursor: default;
    }

    .p-button-icon-right {
        order: 1;
    }

    .p-button-icon-right:dir(rtl) {
        order: -1;
    }

    .p-button:not(.p-button-vertical) .p-button-icon:not(.p-button-icon-right):dir(rtl) {
        order: 1;
    }

    .p-button-icon-bottom {
        order: 2;
    }

    .p-button-icon-only {
        width: dt('button.icon.only.width');
        padding-inline-start: 0;
        padding-inline-end: 0;
        gap: 0;
    }

    .p-button-icon-only.p-button-rounded {
        border-radius: 50%;
        height: dt('button.icon.only.width');
    }

    .p-button-icon-only .p-button-label {
        visibility: hidden;
        width: 0;
    }

    .p-button-icon-only::after {
        content: " ";
        visibility: hidden;
        width: 0;
    }

    .p-button-sm {
        font-size: dt('button.sm.font.size');
        padding: dt('button.sm.padding.y') dt('button.sm.padding.x');
    }

    .p-button-sm .p-button-icon {
        font-size: dt('button.sm.font.size');
    }

    .p-button-sm.p-button-icon-only {
        width: dt('button.sm.icon.only.width');
    }

    .p-button-sm.p-button-icon-only.p-button-rounded {
        height: dt('button.sm.icon.only.width');
    }

    .p-button-lg {
        font-size: dt('button.lg.font.size');
        padding: dt('button.lg.padding.y') dt('button.lg.padding.x');
    }

    .p-button-lg .p-button-icon {
        font-size: dt('button.lg.font.size');
    }

    .p-button-lg.p-button-icon-only {
        width: dt('button.lg.icon.only.width');
    }

    .p-button-lg.p-button-icon-only.p-button-rounded {
        height: dt('button.lg.icon.only.width');
    }

    .p-button-vertical {
        flex-direction: column;
    }

    .p-button-label {
        font-weight: dt('button.label.font.weight');
    }

    .p-button-fluid {
        width: 100%;
    }

    .p-button-fluid.p-button-icon-only {
        width: dt('button.icon.only.width');
    }

    .p-button:not(:disabled):hover {
        background: dt('button.primary.hover.background');
        border: 1px solid dt('button.primary.hover.border.color');
        color: dt('button.primary.hover.color');
    }

    .p-button:not(:disabled):active {
        background: dt('button.primary.active.background');
        border: 1px solid dt('button.primary.active.border.color');
        color: dt('button.primary.active.color');
    }

    .p-button:focus-visible {
        box-shadow: dt('button.primary.focus.ring.shadow');
        outline: dt('button.focus.ring.width') dt('button.focus.ring.style') dt('button.primary.focus.ring.color');
        outline-offset: dt('button.focus.ring.offset');
    }

    .p-button .p-badge {
        min-width: dt('button.badge.size');
        height: dt('button.badge.size');
        line-height: dt('button.badge.size');
    }

    .p-button-raised {
        box-shadow: dt('button.raised.shadow');
    }

    .p-button-rounded {
        border-radius: dt('button.rounded.border.radius');
    }

    .p-button-secondary {
        background: dt('button.secondary.background');
        border: 1px solid dt('button.secondary.border.color');
        color: dt('button.secondary.color');
    }

    .p-button-secondary:not(:disabled):hover {
        background: dt('button.secondary.hover.background');
        border: 1px solid dt('button.secondary.hover.border.color');
        color: dt('button.secondary.hover.color');
    }

    .p-button-secondary:not(:disabled):active {
        background: dt('button.secondary.active.background');
        border: 1px solid dt('button.secondary.active.border.color');
        color: dt('button.secondary.active.color');
    }

    .p-button-secondary:focus-visible {
        outline-color: dt('button.secondary.focus.ring.color');
        box-shadow: dt('button.secondary.focus.ring.shadow');
    }

    .p-button-success {
        background: dt('button.success.background');
        border: 1px solid dt('button.success.border.color');
        color: dt('button.success.color');
    }

    .p-button-success:not(:disabled):hover {
        background: dt('button.success.hover.background');
        border: 1px solid dt('button.success.hover.border.color');
        color: dt('button.success.hover.color');
    }

    .p-button-success:not(:disabled):active {
        background: dt('button.success.active.background');
        border: 1px solid dt('button.success.active.border.color');
        color: dt('button.success.active.color');
    }

    .p-button-success:focus-visible {
        outline-color: dt('button.success.focus.ring.color');
        box-shadow: dt('button.success.focus.ring.shadow');
    }

    .p-button-info {
        background: dt('button.info.background');
        border: 1px solid dt('button.info.border.color');
        color: dt('button.info.color');
    }

    .p-button-info:not(:disabled):hover {
        background: dt('button.info.hover.background');
        border: 1px solid dt('button.info.hover.border.color');
        color: dt('button.info.hover.color');
    }

    .p-button-info:not(:disabled):active {
        background: dt('button.info.active.background');
        border: 1px solid dt('button.info.active.border.color');
        color: dt('button.info.active.color');
    }

    .p-button-info:focus-visible {
        outline-color: dt('button.info.focus.ring.color');
        box-shadow: dt('button.info.focus.ring.shadow');
    }

    .p-button-warn {
        background: dt('button.warn.background');
        border: 1px solid dt('button.warn.border.color');
        color: dt('button.warn.color');
    }

    .p-button-warn:not(:disabled):hover {
        background: dt('button.warn.hover.background');
        border: 1px solid dt('button.warn.hover.border.color');
        color: dt('button.warn.hover.color');
    }

    .p-button-warn:not(:disabled):active {
        background: dt('button.warn.active.background');
        border: 1px solid dt('button.warn.active.border.color');
        color: dt('button.warn.active.color');
    }

    .p-button-warn:focus-visible {
        outline-color: dt('button.warn.focus.ring.color');
        box-shadow: dt('button.warn.focus.ring.shadow');
    }

    .p-button-help {
        background: dt('button.help.background');
        border: 1px solid dt('button.help.border.color');
        color: dt('button.help.color');
    }

    .p-button-help:not(:disabled):hover {
        background: dt('button.help.hover.background');
        border: 1px solid dt('button.help.hover.border.color');
        color: dt('button.help.hover.color');
    }

    .p-button-help:not(:disabled):active {
        background: dt('button.help.active.background');
        border: 1px solid dt('button.help.active.border.color');
        color: dt('button.help.active.color');
    }

    .p-button-help:focus-visible {
        outline-color: dt('button.help.focus.ring.color');
        box-shadow: dt('button.help.focus.ring.shadow');
    }

    .p-button-danger {
        background: dt('button.danger.background');
        border: 1px solid dt('button.danger.border.color');
        color: dt('button.danger.color');
    }

    .p-button-danger:not(:disabled):hover {
        background: dt('button.danger.hover.background');
        border: 1px solid dt('button.danger.hover.border.color');
        color: dt('button.danger.hover.color');
    }

    .p-button-danger:not(:disabled):active {
        background: dt('button.danger.active.background');
        border: 1px solid dt('button.danger.active.border.color');
        color: dt('button.danger.active.color');
    }

    .p-button-danger:focus-visible {
        outline-color: dt('button.danger.focus.ring.color');
        box-shadow: dt('button.danger.focus.ring.shadow');
    }

    .p-button-contrast {
        background: dt('button.contrast.background');
        border: 1px solid dt('button.contrast.border.color');
        color: dt('button.contrast.color');
    }

    .p-button-contrast:not(:disabled):hover {
        background: dt('button.contrast.hover.background');
        border: 1px solid dt('button.contrast.hover.border.color');
        color: dt('button.contrast.hover.color');
    }

    .p-button-contrast:not(:disabled):active {
        background: dt('button.contrast.active.background');
        border: 1px solid dt('button.contrast.active.border.color');
        color: dt('button.contrast.active.color');
    }

    .p-button-contrast:focus-visible {
        outline-color: dt('button.contrast.focus.ring.color');
        box-shadow: dt('button.contrast.focus.ring.shadow');
    }

    .p-button-outlined {
        background: transparent;
        border-color: dt('button.outlined.primary.border.color');
        color: dt('button.outlined.primary.color');
    }

    .p-button-outlined:not(:disabled):hover {
        background: dt('button.outlined.primary.hover.background');
        border-color: dt('button.outlined.primary.border.color');
        color: dt('button.outlined.primary.color');
    }

    .p-button-outlined:not(:disabled):active {
        background: dt('button.outlined.primary.active.background');
        border-color: dt('button.outlined.primary.border.color');
        color: dt('button.outlined.primary.color');
    }

    .p-button-outlined.p-button-secondary {
        border-color: dt('button.outlined.secondary.border.color');
        color: dt('button.outlined.secondary.color');
    }

    .p-button-outlined.p-button-secondary:not(:disabled):hover {
        background: dt('button.outlined.secondary.hover.background');
        border-color: dt('button.outlined.secondary.border.color');
        color: dt('button.outlined.secondary.color');
    }

    .p-button-outlined.p-button-secondary:not(:disabled):active {
        background: dt('button.outlined.secondary.active.background');
        border-color: dt('button.outlined.secondary.border.color');
        color: dt('button.outlined.secondary.color');
    }

    .p-button-outlined.p-button-success {
        border-color: dt('button.outlined.success.border.color');
        color: dt('button.outlined.success.color');
    }

    .p-button-outlined.p-button-success:not(:disabled):hover {
        background: dt('button.outlined.success.hover.background');
        border-color: dt('button.outlined.success.border.color');
        color: dt('button.outlined.success.color');
    }

    .p-button-outlined.p-button-success:not(:disabled):active {
        background: dt('button.outlined.success.active.background');
        border-color: dt('button.outlined.success.border.color');
        color: dt('button.outlined.success.color');
    }

    .p-button-outlined.p-button-info {
        border-color: dt('button.outlined.info.border.color');
        color: dt('button.outlined.info.color');
    }

    .p-button-outlined.p-button-info:not(:disabled):hover {
        background: dt('button.outlined.info.hover.background');
        border-color: dt('button.outlined.info.border.color');
        color: dt('button.outlined.info.color');
    }

    .p-button-outlined.p-button-info:not(:disabled):active {
        background: dt('button.outlined.info.active.background');
        border-color: dt('button.outlined.info.border.color');
        color: dt('button.outlined.info.color');
    }

    .p-button-outlined.p-button-warn {
        border-color: dt('button.outlined.warn.border.color');
        color: dt('button.outlined.warn.color');
    }

    .p-button-outlined.p-button-warn:not(:disabled):hover {
        background: dt('button.outlined.warn.hover.background');
        border-color: dt('button.outlined.warn.border.color');
        color: dt('button.outlined.warn.color');
    }

    .p-button-outlined.p-button-warn:not(:disabled):active {
        background: dt('button.outlined.warn.active.background');
        border-color: dt('button.outlined.warn.border.color');
        color: dt('button.outlined.warn.color');
    }

    .p-button-outlined.p-button-help {
        border-color: dt('button.outlined.help.border.color');
        color: dt('button.outlined.help.color');
    }

    .p-button-outlined.p-button-help:not(:disabled):hover {
        background: dt('button.outlined.help.hover.background');
        border-color: dt('button.outlined.help.border.color');
        color: dt('button.outlined.help.color');
    }

    .p-button-outlined.p-button-help:not(:disabled):active {
        background: dt('button.outlined.help.active.background');
        border-color: dt('button.outlined.help.border.color');
        color: dt('button.outlined.help.color');
    }

    .p-button-outlined.p-button-danger {
        border-color: dt('button.outlined.danger.border.color');
        color: dt('button.outlined.danger.color');
    }

    .p-button-outlined.p-button-danger:not(:disabled):hover {
        background: dt('button.outlined.danger.hover.background');
        border-color: dt('button.outlined.danger.border.color');
        color: dt('button.outlined.danger.color');
    }

    .p-button-outlined.p-button-danger:not(:disabled):active {
        background: dt('button.outlined.danger.active.background');
        border-color: dt('button.outlined.danger.border.color');
        color: dt('button.outlined.danger.color');
    }

    .p-button-outlined.p-button-contrast {
        border-color: dt('button.outlined.contrast.border.color');
        color: dt('button.outlined.contrast.color');
    }

    .p-button-outlined.p-button-contrast:not(:disabled):hover {
        background: dt('button.outlined.contrast.hover.background');
        border-color: dt('button.outlined.contrast.border.color');
        color: dt('button.outlined.contrast.color');
    }

    .p-button-outlined.p-button-contrast:not(:disabled):active {
        background: dt('button.outlined.contrast.active.background');
        border-color: dt('button.outlined.contrast.border.color');
        color: dt('button.outlined.contrast.color');
    }

    .p-button-outlined.p-button-plain {
        border-color: dt('button.outlined.plain.border.color');
        color: dt('button.outlined.plain.color');
    }

    .p-button-outlined.p-button-plain:not(:disabled):hover {
        background: dt('button.outlined.plain.hover.background');
        border-color: dt('button.outlined.plain.border.color');
        color: dt('button.outlined.plain.color');
    }

    .p-button-outlined.p-button-plain:not(:disabled):active {
        background: dt('button.outlined.plain.active.background');
        border-color: dt('button.outlined.plain.border.color');
        color: dt('button.outlined.plain.color');
    }

    .p-button-text {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.primary.color');
    }

    .p-button-text:not(:disabled):hover {
        background: dt('button.text.primary.hover.background');
        border-color: transparent;
        color: dt('button.text.primary.color');
    }

    .p-button-text:not(:disabled):active {
        background: dt('button.text.primary.active.background');
        border-color: transparent;
        color: dt('button.text.primary.color');
    }

    .p-button-text.p-button-secondary {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.secondary.color');
    }

    .p-button-text.p-button-secondary:not(:disabled):hover {
        background: dt('button.text.secondary.hover.background');
        border-color: transparent;
        color: dt('button.text.secondary.color');
    }

    .p-button-text.p-button-secondary:not(:disabled):active {
        background: dt('button.text.secondary.active.background');
        border-color: transparent;
        color: dt('button.text.secondary.color');
    }

    .p-button-text.p-button-success {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.success.color');
    }

    .p-button-text.p-button-success:not(:disabled):hover {
        background: dt('button.text.success.hover.background');
        border-color: transparent;
        color: dt('button.text.success.color');
    }

    .p-button-text.p-button-success:not(:disabled):active {
        background: dt('button.text.success.active.background');
        border-color: transparent;
        color: dt('button.text.success.color');
    }

    .p-button-text.p-button-info {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.info.color');
    }

    .p-button-text.p-button-info:not(:disabled):hover {
        background: dt('button.text.info.hover.background');
        border-color: transparent;
        color: dt('button.text.info.color');
    }

    .p-button-text.p-button-info:not(:disabled):active {
        background: dt('button.text.info.active.background');
        border-color: transparent;
        color: dt('button.text.info.color');
    }

    .p-button-text.p-button-warn {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.warn.color');
    }

    .p-button-text.p-button-warn:not(:disabled):hover {
        background: dt('button.text.warn.hover.background');
        border-color: transparent;
        color: dt('button.text.warn.color');
    }

    .p-button-text.p-button-warn:not(:disabled):active {
        background: dt('button.text.warn.active.background');
        border-color: transparent;
        color: dt('button.text.warn.color');
    }

    .p-button-text.p-button-help {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.help.color');
    }

    .p-button-text.p-button-help:not(:disabled):hover {
        background: dt('button.text.help.hover.background');
        border-color: transparent;
        color: dt('button.text.help.color');
    }

    .p-button-text.p-button-help:not(:disabled):active {
        background: dt('button.text.help.active.background');
        border-color: transparent;
        color: dt('button.text.help.color');
    }

    .p-button-text.p-button-danger {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.danger.color');
    }

    .p-button-text.p-button-danger:not(:disabled):hover {
        background: dt('button.text.danger.hover.background');
        border-color: transparent;
        color: dt('button.text.danger.color');
    }

    .p-button-text.p-button-danger:not(:disabled):active {
        background: dt('button.text.danger.active.background');
        border-color: transparent;
        color: dt('button.text.danger.color');
    }

    .p-button-text.p-button-contrast {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.contrast.color');
    }

    .p-button-text.p-button-contrast:not(:disabled):hover {
        background: dt('button.text.contrast.hover.background');
        border-color: transparent;
        color: dt('button.text.contrast.color');
    }

    .p-button-text.p-button-contrast:not(:disabled):active {
        background: dt('button.text.contrast.active.background');
        border-color: transparent;
        color: dt('button.text.contrast.color');
    }

    .p-button-text.p-button-plain {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.plain.color');
    }

    .p-button-text.p-button-plain:not(:disabled):hover {
        background: dt('button.text.plain.hover.background');
        border-color: transparent;
        color: dt('button.text.plain.color');
    }

    .p-button-text.p-button-plain:not(:disabled):active {
        background: dt('button.text.plain.active.background');
        border-color: transparent;
        color: dt('button.text.plain.color');
    }

    .p-button-link {
        background: transparent;
        border-color: transparent;
        color: dt('button.link.color');
    }

    .p-button-link:not(:disabled):hover {
        background: transparent;
        border-color: transparent;
        color: dt('button.link.hover.color');
    }

    .p-button-link:not(:disabled):hover .p-button-label {
        text-decoration: underline;
    }

    .p-button-link:not(:disabled):active {
        background: transparent;
        border-color: transparent;
        color: dt('button.link.active.color');
    }
`;
function Re(e) {
  "@babel/helpers - typeof";
  return Re = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Re(e);
}
function le(e, t, n) {
  return (t = Qr(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Qr(e) {
  var t = Jr(e, "string");
  return Re(t) == "symbol" ? t : t + "";
}
function Jr(e, t) {
  if (Re(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Re(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ea = {
  root: function(t) {
    var n = t.instance, o = t.props;
    return ["p-button p-component", le(le(le(le(le(le(le(le(le({
      "p-button-icon-only": n.hasIcon && !o.label && !o.badge,
      "p-button-vertical": (o.iconPos === "top" || o.iconPos === "bottom") && o.label,
      "p-button-loading": o.loading,
      "p-button-link": o.link || o.variant === "link"
    }, "p-button-".concat(o.severity), o.severity), "p-button-raised", o.raised), "p-button-rounded", o.rounded), "p-button-text", o.text || o.variant === "text"), "p-button-outlined", o.outlined || o.variant === "outlined"), "p-button-sm", o.size === "small"), "p-button-lg", o.size === "large"), "p-button-plain", o.plain), "p-button-fluid", n.hasFluid)];
  },
  loadingIcon: "p-button-loading-icon",
  icon: function(t) {
    var n = t.props;
    return ["p-button-icon", le({}, "p-button-icon-".concat(n.iconPos), n.label)];
  },
  label: "p-button-label"
}, ta = R.extend({
  name: "button",
  style: Xr,
  classes: ea
}), na = {
  name: "BaseButton",
  extends: Ge,
  props: {
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconPos: {
      type: String,
      default: "left"
    },
    iconClass: {
      type: [String, Object],
      default: null
    },
    badge: {
      type: String,
      default: null
    },
    badgeClass: {
      type: [String, Object],
      default: null
    },
    badgeSeverity: {
      type: String,
      default: "secondary"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingIcon: {
      type: String,
      default: void 0
    },
    as: {
      type: [String, Object],
      default: "BUTTON"
    },
    asChild: {
      type: Boolean,
      default: !1
    },
    link: {
      type: Boolean,
      default: !1
    },
    severity: {
      type: String,
      default: null
    },
    raised: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    text: {
      type: Boolean,
      default: !1
    },
    outlined: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: null
    },
    plain: {
      type: Boolean,
      default: !1
    },
    fluid: {
      type: Boolean,
      default: null
    }
  },
  style: ta,
  provide: function() {
    return {
      $pcButton: this,
      $parentInstance: this
    };
  }
};
function Ke(e) {
  "@babel/helpers - typeof";
  return Ke = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ke(e);
}
function J(e, t, n) {
  return (t = oa(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function oa(e) {
  var t = ra(e, "string");
  return Ke(t) == "symbol" ? t : t + "";
}
function ra(e, t) {
  if (Ke(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Ke(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ce = {
  name: "Button",
  extends: na,
  inheritAttrs: !1,
  inject: {
    $pcFluid: {
      default: null
    }
  },
  methods: {
    getPTOptions: function(t) {
      var n = t === "root" ? this.ptmi : this.ptm;
      return n(t, {
        context: {
          disabled: this.disabled
        }
      });
    }
  },
  computed: {
    disabled: function() {
      return this.$attrs.disabled || this.$attrs.disabled === "" || this.loading;
    },
    defaultAriaLabel: function() {
      return this.label ? this.label + (this.badge ? " " + this.badge : "") : this.$attrs.ariaLabel;
    },
    hasIcon: function() {
      return this.icon || this.$slots.icon;
    },
    attrs: function() {
      return z(this.asAttrs, this.a11yAttrs, this.getPTOptions("root"));
    },
    asAttrs: function() {
      return this.as === "BUTTON" ? {
        type: "button",
        disabled: this.disabled
      } : void 0;
    },
    a11yAttrs: function() {
      return {
        "aria-label": this.defaultAriaLabel,
        "data-pc-name": "button",
        "data-p-disabled": this.disabled,
        "data-p-severity": this.severity
      };
    },
    hasFluid: function() {
      return Se(this.fluid) ? !!this.$pcFluid : this.fluid;
    },
    dataP: function() {
      return ye(J(J(J(J(J(J(J(J(J(J({}, this.size, this.size), "icon-only", this.hasIcon && !this.label && !this.badge), "loading", this.loading), "fluid", this.hasFluid), "rounded", this.rounded), "raised", this.raised), "outlined", this.outlined || this.variant === "outlined"), "text", this.text || this.variant === "text"), "link", this.link || this.variant === "link"), "vertical", (this.iconPos === "top" || this.iconPos === "bottom") && this.label));
    },
    dataIconP: function() {
      return ye(J(J({}, this.iconPos, this.iconPos), this.size, this.size));
    },
    dataLabelP: function() {
      return ye(J(J({}, this.size, this.size), "icon-only", this.hasIcon && !this.label && !this.badge));
    }
  },
  components: {
    SpinnerIcon: Ln,
    Badge: En
  },
  directives: {
    ripple: zn
  }
}, aa = ["data-p"], ia = ["data-p"];
function la(e, t, n, o, r, l) {
  var s = $t("SpinnerIcon"), i = $t("Badge"), a = cn("ripple");
  return e.asChild ? pe(e.$slots, "default", {
    key: 1,
    class: ke(e.cx("root")),
    a11yAttrs: l.a11yAttrs
  }) : at((k(), oe(pn(e.as), z({
    key: 0,
    class: e.cx("root"),
    "data-p": l.dataP
  }, l.attrs), {
    default: Ee(function() {
      return [pe(e.$slots, "default", {}, function() {
        return [e.loading ? pe(e.$slots, "loadingicon", z({
          key: 0,
          class: [e.cx("loadingIcon"), e.cx("icon")]
        }, e.ptm("loadingIcon")), function() {
          return [e.loadingIcon ? (k(), C("span", z({
            key: 0,
            class: [e.cx("loadingIcon"), e.cx("icon"), e.loadingIcon]
          }, e.ptm("loadingIcon")), null, 16)) : (k(), oe(s, z({
            key: 1,
            class: [e.cx("loadingIcon"), e.cx("icon")],
            spin: ""
          }, e.ptm("loadingIcon")), null, 16, ["class"]))];
        }) : pe(e.$slots, "icon", z({
          key: 1,
          class: [e.cx("icon")]
        }, e.ptm("icon")), function() {
          return [e.icon ? (k(), C("span", z({
            key: 0,
            class: [e.cx("icon"), e.icon, e.iconClass],
            "data-p": l.dataIconP
          }, e.ptm("icon")), null, 16, aa)) : D("", !0)];
        }), e.label ? (k(), C("span", z({
          key: 2,
          class: e.cx("label")
        }, e.ptm("label"), {
          "data-p": l.dataLabelP
        }), Y(e.label), 17, ia)) : D("", !0), e.badge ? (k(), oe(i, {
          key: 3,
          value: e.badge,
          class: ke(e.badgeClass),
          severity: e.badgeSeverity,
          unstyled: e.unstyled,
          pt: e.ptm("pcBadge")
        }, null, 8, ["value", "class", "severity", "unstyled", "pt"])) : D("", !0)];
      })];
    }),
    _: 3
  }, 16, ["class", "data-p"])), [[a]]);
}
Ce.render = la;
var An = {
  name: "TimesIcon",
  extends: Nn
};
function sa(e) {
  return pa(e) || ca(e) || ua(e) || da();
}
function da() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ua(e, t) {
  if (e) {
    if (typeof e == "string") return Ct(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ct(e, t) : void 0;
  }
}
function ca(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function pa(e) {
  if (Array.isArray(e)) return Ct(e);
}
function Ct(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function ma(e, t, n, o, r, l) {
  return k(), C("svg", z({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), sa(t[0] || (t[0] = [V("path", {
    d: "M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
An.render = ma;
var fa = `
    .p-message {
        display: grid;
        grid-template-rows: 1fr;
        border-radius: dt('message.border.radius');
        outline-width: dt('message.border.width');
        outline-style: solid;
    }

    .p-message-content-wrapper {
        min-height: 0;
    }

    .p-message-content {
        display: flex;
        align-items: center;
        padding: dt('message.content.padding');
        gap: dt('message.content.gap');
    }

    .p-message-icon {
        flex-shrink: 0;
    }

    .p-message-close-button {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-inline-start: auto;
        overflow: hidden;
        position: relative;
        width: dt('message.close.button.width');
        height: dt('message.close.button.height');
        border-radius: dt('message.close.button.border.radius');
        background: transparent;
        transition:
            background dt('message.transition.duration'),
            color dt('message.transition.duration'),
            outline-color dt('message.transition.duration'),
            box-shadow dt('message.transition.duration'),
            opacity 0.3s;
        outline-color: transparent;
        color: inherit;
        padding: 0;
        border: none;
        cursor: pointer;
        user-select: none;
    }

    .p-message-close-icon {
        font-size: dt('message.close.icon.size');
        width: dt('message.close.icon.size');
        height: dt('message.close.icon.size');
    }

    .p-message-close-button:focus-visible {
        outline-width: dt('message.close.button.focus.ring.width');
        outline-style: dt('message.close.button.focus.ring.style');
        outline-offset: dt('message.close.button.focus.ring.offset');
    }

    .p-message-info {
        background: dt('message.info.background');
        outline-color: dt('message.info.border.color');
        color: dt('message.info.color');
        box-shadow: dt('message.info.shadow');
    }

    .p-message-info .p-message-close-button:focus-visible {
        outline-color: dt('message.info.close.button.focus.ring.color');
        box-shadow: dt('message.info.close.button.focus.ring.shadow');
    }

    .p-message-info .p-message-close-button:hover {
        background: dt('message.info.close.button.hover.background');
    }

    .p-message-info.p-message-outlined {
        color: dt('message.info.outlined.color');
        outline-color: dt('message.info.outlined.border.color');
    }

    .p-message-info.p-message-simple {
        color: dt('message.info.simple.color');
    }

    .p-message-success {
        background: dt('message.success.background');
        outline-color: dt('message.success.border.color');
        color: dt('message.success.color');
        box-shadow: dt('message.success.shadow');
    }

    .p-message-success .p-message-close-button:focus-visible {
        outline-color: dt('message.success.close.button.focus.ring.color');
        box-shadow: dt('message.success.close.button.focus.ring.shadow');
    }

    .p-message-success .p-message-close-button:hover {
        background: dt('message.success.close.button.hover.background');
    }

    .p-message-success.p-message-outlined {
        color: dt('message.success.outlined.color');
        outline-color: dt('message.success.outlined.border.color');
    }

    .p-message-success.p-message-simple {
        color: dt('message.success.simple.color');
    }

    .p-message-warn {
        background: dt('message.warn.background');
        outline-color: dt('message.warn.border.color');
        color: dt('message.warn.color');
        box-shadow: dt('message.warn.shadow');
    }

    .p-message-warn .p-message-close-button:focus-visible {
        outline-color: dt('message.warn.close.button.focus.ring.color');
        box-shadow: dt('message.warn.close.button.focus.ring.shadow');
    }

    .p-message-warn .p-message-close-button:hover {
        background: dt('message.warn.close.button.hover.background');
    }

    .p-message-warn.p-message-outlined {
        color: dt('message.warn.outlined.color');
        outline-color: dt('message.warn.outlined.border.color');
    }

    .p-message-warn.p-message-simple {
        color: dt('message.warn.simple.color');
    }

    .p-message-error {
        background: dt('message.error.background');
        outline-color: dt('message.error.border.color');
        color: dt('message.error.color');
        box-shadow: dt('message.error.shadow');
    }

    .p-message-error .p-message-close-button:focus-visible {
        outline-color: dt('message.error.close.button.focus.ring.color');
        box-shadow: dt('message.error.close.button.focus.ring.shadow');
    }

    .p-message-error .p-message-close-button:hover {
        background: dt('message.error.close.button.hover.background');
    }

    .p-message-error.p-message-outlined {
        color: dt('message.error.outlined.color');
        outline-color: dt('message.error.outlined.border.color');
    }

    .p-message-error.p-message-simple {
        color: dt('message.error.simple.color');
    }

    .p-message-secondary {
        background: dt('message.secondary.background');
        outline-color: dt('message.secondary.border.color');
        color: dt('message.secondary.color');
        box-shadow: dt('message.secondary.shadow');
    }

    .p-message-secondary .p-message-close-button:focus-visible {
        outline-color: dt('message.secondary.close.button.focus.ring.color');
        box-shadow: dt('message.secondary.close.button.focus.ring.shadow');
    }

    .p-message-secondary .p-message-close-button:hover {
        background: dt('message.secondary.close.button.hover.background');
    }

    .p-message-secondary.p-message-outlined {
        color: dt('message.secondary.outlined.color');
        outline-color: dt('message.secondary.outlined.border.color');
    }

    .p-message-secondary.p-message-simple {
        color: dt('message.secondary.simple.color');
    }

    .p-message-contrast {
        background: dt('message.contrast.background');
        outline-color: dt('message.contrast.border.color');
        color: dt('message.contrast.color');
        box-shadow: dt('message.contrast.shadow');
    }

    .p-message-contrast .p-message-close-button:focus-visible {
        outline-color: dt('message.contrast.close.button.focus.ring.color');
        box-shadow: dt('message.contrast.close.button.focus.ring.shadow');
    }

    .p-message-contrast .p-message-close-button:hover {
        background: dt('message.contrast.close.button.hover.background');
    }

    .p-message-contrast.p-message-outlined {
        color: dt('message.contrast.outlined.color');
        outline-color: dt('message.contrast.outlined.border.color');
    }

    .p-message-contrast.p-message-simple {
        color: dt('message.contrast.simple.color');
    }

    .p-message-text {
        font-size: dt('message.text.font.size');
        font-weight: dt('message.text.font.weight');
    }

    .p-message-icon {
        font-size: dt('message.icon.size');
        width: dt('message.icon.size');
        height: dt('message.icon.size');
    }

    .p-message-sm .p-message-content {
        padding: dt('message.content.sm.padding');
    }

    .p-message-sm .p-message-text {
        font-size: dt('message.text.sm.font.size');
    }

    .p-message-sm .p-message-icon {
        font-size: dt('message.icon.sm.size');
        width: dt('message.icon.sm.size');
        height: dt('message.icon.sm.size');
    }

    .p-message-sm .p-message-close-icon {
        font-size: dt('message.close.icon.sm.size');
        width: dt('message.close.icon.sm.size');
        height: dt('message.close.icon.sm.size');
    }

    .p-message-lg .p-message-content {
        padding: dt('message.content.lg.padding');
    }

    .p-message-lg .p-message-text {
        font-size: dt('message.text.lg.font.size');
    }

    .p-message-lg .p-message-icon {
        font-size: dt('message.icon.lg.size');
        width: dt('message.icon.lg.size');
        height: dt('message.icon.lg.size');
    }

    .p-message-lg .p-message-close-icon {
        font-size: dt('message.close.icon.lg.size');
        width: dt('message.close.icon.lg.size');
        height: dt('message.close.icon.lg.size');
    }

    .p-message-outlined {
        background: transparent;
        outline-width: dt('message.outlined.border.width');
    }

    .p-message-simple {
        background: transparent;
        outline-color: transparent;
        box-shadow: none;
    }

    .p-message-simple .p-message-content {
        padding: dt('message.simple.content.padding');
    }

    .p-message-outlined .p-message-close-button:hover,
    .p-message-simple .p-message-close-button:hover {
        background: transparent;
    }

    .p-message-enter-active {
        animation: p-animate-message-enter 0.3s ease-out forwards;
        overflow: hidden;
    }

    .p-message-leave-active {
        animation: p-animate-message-leave 0.15s ease-in forwards;
        overflow: hidden;
    }

    @keyframes p-animate-message-enter {
        from {
            opacity: 0;
            grid-template-rows: 0fr;
        }
        to {
            opacity: 1;
            grid-template-rows: 1fr;
        }
    }

    @keyframes p-animate-message-leave {
        from {
            opacity: 1;
            grid-template-rows: 1fr;
        }
        to {
            opacity: 0;
            margin: 0;
            grid-template-rows: 0fr;
        }
    }
`, ba = {
  root: function(t) {
    var n = t.props;
    return ["p-message p-component p-message-" + n.severity, {
      "p-message-outlined": n.variant === "outlined",
      "p-message-simple": n.variant === "simple",
      "p-message-sm": n.size === "small",
      "p-message-lg": n.size === "large"
    }];
  },
  contentWrapper: "p-message-content-wrapper",
  content: "p-message-content",
  icon: "p-message-icon",
  text: "p-message-text",
  closeButton: "p-message-close-button",
  closeIcon: "p-message-close-icon"
}, ga = R.extend({
  name: "message",
  style: fa,
  classes: ba
}), va = {
  name: "BaseMessage",
  extends: Ge,
  props: {
    severity: {
      type: String,
      default: "info"
    },
    closable: {
      type: Boolean,
      default: !1
    },
    life: {
      type: Number,
      default: null
    },
    icon: {
      type: String,
      default: void 0
    },
    closeIcon: {
      type: String,
      default: void 0
    },
    closeButtonProps: {
      type: null,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: null
    }
  },
  style: ga,
  provide: function() {
    return {
      $pcMessage: this,
      $parentInstance: this
    };
  }
};
function We(e) {
  "@babel/helpers - typeof";
  return We = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, We(e);
}
function an(e, t, n) {
  return (t = ha(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ha(e) {
  var t = ya(e, "string");
  return We(t) == "symbol" ? t : t + "";
}
function ya(e, t) {
  if (We(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (We(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var rt = {
  name: "Message",
  extends: va,
  inheritAttrs: !1,
  emits: ["close", "life-end"],
  timeout: null,
  data: function() {
    return {
      visible: !0
    };
  },
  mounted: function() {
    var t = this;
    this.life && setTimeout(function() {
      t.visible = !1, t.$emit("life-end");
    }, this.life);
  },
  methods: {
    close: function(t) {
      this.visible = !1, this.$emit("close", t);
    }
  },
  computed: {
    closeAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.close : void 0;
    },
    dataP: function() {
      return ye(an(an({
        outlined: this.variant === "outlined",
        simple: this.variant === "simple"
      }, this.severity, this.severity), this.size, this.size));
    }
  },
  directives: {
    ripple: zn
  },
  components: {
    TimesIcon: An
  }
};
function He(e) {
  "@babel/helpers - typeof";
  return He = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, He(e);
}
function ln(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function sn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ln(Object(n), !0).forEach(function(o) {
      $a(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ln(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function $a(e, t, n) {
  return (t = _a(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _a(e) {
  var t = ka(e, "string");
  return He(t) == "symbol" ? t : t + "";
}
function ka(e, t) {
  if (He(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (He(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Sa = ["data-p"], wa = ["data-p"], Pa = ["data-p"], xa = ["aria-label", "data-p"], Ca = ["data-p"];
function Oa(e, t, n, o, r, l) {
  var s = $t("TimesIcon"), i = cn("ripple");
  return k(), oe(Yn, z({
    name: "p-message",
    appear: ""
  }, e.ptmi("transition")), {
    default: Ee(function() {
      return [r.visible ? (k(), C("div", z({
        key: 0,
        class: e.cx("root"),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true",
        "data-p": l.dataP
      }, e.ptm("root")), [V("div", z({
        class: e.cx("contentWrapper")
      }, e.ptm("contentWrapper")), [e.$slots.container ? pe(e.$slots, "container", {
        key: 0,
        closeCallback: l.close
      }) : (k(), C("div", z({
        key: 1,
        class: e.cx("content"),
        "data-p": l.dataP
      }, e.ptm("content")), [pe(e.$slots, "icon", {
        class: ke(e.cx("icon"))
      }, function() {
        return [(k(), oe(pn(e.icon ? "span" : null), z({
          class: [e.cx("icon"), e.icon],
          "data-p": l.dataP
        }, e.ptm("icon")), null, 16, ["class", "data-p"]))];
      }), e.$slots.default ? (k(), C("div", z({
        key: 0,
        class: e.cx("text"),
        "data-p": l.dataP
      }, e.ptm("text")), [pe(e.$slots, "default")], 16, Pa)) : D("", !0), e.closable ? at((k(), C("button", z({
        key: 1,
        class: e.cx("closeButton"),
        "aria-label": l.closeAriaLabel,
        type: "button",
        onClick: t[0] || (t[0] = function(a) {
          return l.close(a);
        }),
        "data-p": l.dataP
      }, sn(sn({}, e.closeButtonProps), e.ptm("closeButton"))), [pe(e.$slots, "closeicon", {}, function() {
        return [e.closeIcon ? (k(), C("i", z({
          key: 0,
          class: [e.cx("closeIcon"), e.closeIcon],
          "data-p": l.dataP
        }, e.ptm("closeIcon")), null, 16, Ca)) : (k(), oe(s, z({
          key: 1,
          class: [e.cx("closeIcon"), e.closeIcon],
          "data-p": l.dataP
        }, e.ptm("closeIcon")), null, 16, ["class", "data-p"]))];
      })], 16, xa)), [[i]]) : D("", !0)], 16, wa))], 16)], 16, Sa)) : D("", !0)];
    }),
    _: 3
  }, 16);
}
rt.render = Oa;
const Ta = {
  key: 0,
  class: "card-field__saved",
  "data-testid": "register__payment-saved"
}, ja = { class: "card-field__saved-row" }, Na = ["data-brand"], La = { class: "card-field__last4" }, Ea = { class: "card-field__field" }, za = {
  key: 0,
  class: "card-field__helper",
  "data-testid": "register__payment-hosted-unavailable"
}, Aa = {
  key: 1,
  class: "card-field__helper",
  "data-testid": "register__payment-hosted-loading"
}, Ia = {
  key: 2,
  class: "card-field__error",
  "data-testid": "register__payment-hosted-error"
}, Va = {
  key: 0,
  class: "card-field__field"
}, Da = {
  key: 3,
  class: "card-field__helper"
}, Ba = { class: "card-field__field" }, Fa = { class: "card-field__number-row" }, Ma = ["data-brand"], Ua = {
  key: 0,
  class: "card-field__error",
  "data-testid": "register__payment-number-error"
}, Ra = { class: "card-field__row" }, Ka = { class: "card-field__field card-field__cell" }, Wa = {
  key: 0,
  class: "card-field__error"
}, Ha = { class: "card-field__field card-field__cell" }, Ya = {
  key: 0,
  class: "card-field__error"
}, Ga = { class: "card-field__field" }, Za = {
  key: 0,
  class: "card-field__error"
}, qa = /* @__PURE__ */ mn({
  __name: "NeonPayCardField",
  props: {
    modelValue: {},
    invalid: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    provider: { default: null },
    autoEmit: { type: Boolean, default: !0 },
    billing: {},
    size: { default: "default" },
    separatePostalCode: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "error", "card-saved", "brand-change"],
  setup(e, { expose: t, emit: n }) {
    const o = e, r = U(() => o.provider !== null), l = U(() => r.value && o.separatePostalCode), s = n, i = Lt({
      number: "",
      exp: "",
      cvc: "",
      postalCode: ""
    }), a = Lt({
      number: null,
      exp: null,
      cvc: null,
      postalCode: null
    }), d = M(!1), u = M(null), c = M(null), p = M(null), m = `np-card-mount-${et()}`, b = M(null), v = `np-card-postal-${et()}`, g = `${v}-error`, {
      ready: $,
      initialized: S,
      canMakePayment: O,
      error: f,
      init: y,
      createToken: _,
      unmount: x,
      remount: A,
      colorSchemeChanged: K,
      on: W
    } = vn({
      publicKey: o.provider?.publicKey ?? "",
      merchantId: o.provider?.merchantId ?? "",
      sandbox: o.provider?.sandbox,
      container: b,
      tokenData: U(() => o.billing),
      fieldOptions: U(() => o.separatePostalCode ? { hidePostalCode: !0 } : void 0),
      // Only ever invoked from inside useNeonPay's init(), which is a no-op while
      // `container` is null — i.e. in mock mode, where the hosted mount is not
      // rendered. So this cannot double up with the mock-mode watch below.
      onBrandChange: (h) => s("brand-change", h)
    }), B = M(!1);
    W("ready", () => {
      B.value = !0;
    });
    const G = U(
      () => S.value && !O.value && !f.value
    ), X = U(
      () => r.value && !B.value && !G.value && !f.value
    );
    be(
      b,
      async (h) => {
        !h || !o.provider || (await y(), f.value && s("error", f.value));
      },
      { immediate: !0 }
    );
    function Q(h) {
      const L = /^mock-token-(visa|mc|amex|disc|unknown)-(\d{4})-(success|pending)$/.exec(
        h
      );
      if (L) {
        c.value = L[1], p.value = L[2];
        return;
      }
      c.value = "unknown", p.value = "••••";
    }
    const Z = M(!1);
    be(
      () => o.modelValue,
      (h) => {
        if (Z.value) {
          Z.value = !1;
          return;
        }
        h && Q(h);
      },
      { immediate: !0 }
    );
    const T = U(
      () => !!o.modelValue && p.value !== null
    );
    let F = null;
    function de() {
      !r.value || d.value || T.value || K() && (B.value = !1, A());
    }
    un(() => {
      F = new MutationObserver(de), F.observe(document.documentElement, {
        attributes: !0,
        attributeFilter: ["class", "style", "data-theme"]
      });
    }), be(d, (h) => {
      h || de();
    }), dn(() => {
      F?.disconnect(), F = null;
    });
    const H = U(() => Ot(i.number));
    be(H, (h) => {
      r.value || s("brand-change", h);
    });
    const re = U(
      () => mt(i.number) && ft(i.exp) && bt(i.cvc, H.value) && gt(i.postalCode)
    );
    be(re, (h) => {
      if (!(!o.autoEmit || r.value))
        if (h) {
          const L = i.number.replace(/\s+/g, "").slice(-4);
          Z.value = !0, s("update:modelValue", `mock-token-${H.value}-${L}-success`);
        } else o.modelValue && s("update:modelValue", "");
    });
    const te = U(() => o.disabled || d.value ? !0 : r.value ? !$.value : !i.number || !i.exp || !i.cvc || !i.postalCode);
    function ue(h) {
      i.number = ao(h ?? ""), a.number = null, u.value = null;
    }
    function we(h) {
      i.exp = io(h ?? ""), a.exp = null, u.value = null;
    }
    function me(h) {
      i.cvc = (h ?? "").replace(/\D/g, "").slice(0, 4), a.cvc = null, u.value = null;
    }
    const Ze = U(() => l.value ? 20 : 10);
    function Oe(h) {
      i.postalCode = (h ?? "").slice(0, Ze.value), a.postalCode = null, u.value = null;
    }
    function it() {
      i.number && (mt(i.number) || (a.number = "Card number looks wrong. Double-check the digits."));
    }
    function lt() {
      i.exp && (ft(i.exp) || (a.exp = "Use MM/YY and a future date."));
    }
    function st() {
      i.cvc && (bt(i.cvc, H.value) || (a.cvc = H.value === "amex" ? "CVC is 4 digits." : "CVC is 3 digits."));
    }
    function dt() {
      i.postalCode && (gt(i.postalCode) || (a.postalCode = "Enter a valid postal code."));
    }
    function ut() {
      let h = !0;
      return mt(i.number) || (a.number = "Card number looks wrong. Double-check the digits.", h = !1), ft(i.exp) || (a.exp = "Use MM/YY and a future date.", h = !1), bt(i.cvc, H.value) || (a.cvc = H.value === "amex" ? "CVC is 4 digits." : "CVC is 3 digits.", h = !1), gt(i.postalCode) || (a.postalCode = "Enter a valid postal code.", h = !1), h;
    }
    async function Te() {
      u.value = null, d.value = !0;
      try {
        let h;
        if (l.value) {
          const L = i.postalCode.trim();
          if (!L) {
            a.postalCode = "Enter your postal code.";
            return;
          }
          h = await _({ address_zip: L });
        } else if (r.value)
          h = await _();
        else {
          if (!ut()) return;
          h = await lo({
            number: i.number,
            exp: i.exp,
            cvc: i.cvc,
            postalCode: i.postalCode
          });
        }
        if (h.status === "decline" && h.field === "postalCode" && l.value) {
          a.postalCode = h.message, s("update:modelValue", "");
          return;
        }
        if (h.status === "decline") {
          u.value = h.message, s("error", h.message), s("update:modelValue", ""), c.value = null, p.value = null;
          return;
        }
        c.value = h.brand, p.value = h.last4, Z.value = !0, s("update:modelValue", h.token), s("card-saved", { token: h.token, brand: h.brand, last4: h.last4, expiration: null });
      } catch (h) {
        const L = h instanceof Error ? h.message : "Something went wrong. Try again.";
        u.value = L, s("error", L), s("update:modelValue", ""), c.value = null, p.value = null;
      } finally {
        d.value = !1;
      }
    }
    function ct() {
      x(), s("update:modelValue", ""), c.value = null, p.value = null, i.number = "", i.exp = "", i.cvc = "", i.postalCode = "", a.number = null, a.exp = null, a.cvc = null, a.postalCode = null, u.value = null;
    }
    async function pt() {
      await Te();
    }
    return t({ tokenize: pt }), (h, L) => (k(), C("div", {
      class: ke(["card-field", { "card-field--large": e.size === "large" }]),
      "data-testid": "register__payment"
    }, [
      T.value ? (k(), C("div", Ta, [
        V("div", ja, [
          V("span", {
            class: "card-field__brand",
            "data-brand": c.value ?? "unknown"
          }, Y(N(At)(c.value ?? "unknown")), 9, Na),
          V("span", La, "•••• " + Y(p.value), 1),
          he(N(Ce), {
            link: "",
            size: "small",
            label: "Change",
            disabled: o.disabled,
            "data-testid": "register__payment-change",
            onClick: ct
          }, null, 8, ["disabled"])
        ])
      ])) : r.value ? (k(), C(_t, { key: 1 }, [
        V("div", Ea, [
          L[0] || (L[0] = V("label", { class: "card-field__label" }, "Card details", -1)),
          at(V("div", {
            id: m,
            ref_key: "hostedMount",
            ref: b,
            class: ke(["card-field__hosted", { "card-field__hosted--loading": X.value }]),
            "data-testid": "register__payment-hosted"
          }, null, 2), [
            [fn, !G.value]
          ]),
          G.value ? (k(), C("small", za, " Card payments aren't available for this merchant in your browser right now. Please try a different browser or contact the organizer. ")) : X.value ? (k(), C("small", Aa, " Loading secure card field… ")) : N(f) ? (k(), C("small", Ia, Y(N(f)), 1)) : D("", !0)
        ]),
        e.separatePostalCode && !G.value ? (k(), C("div", Va, [
          V("label", {
            for: v,
            class: "card-field__label"
          }, "Postal code"),
          he(N(xe), {
            id: v,
            "model-value": i.postalCode,
            autocomplete: "postal-code",
            maxlength: "20",
            "aria-required": "true",
            fluid: "",
            size: e.size === "large" ? "large" : void 0,
            disabled: o.disabled || d.value,
            invalid: a.postalCode !== null,
            "aria-describedby": a.postalCode ? g : void 0,
            "data-testid": "register__payment-postal",
            "onUpdate:modelValue": Oe
          }, null, 8, ["model-value", "size", "disabled", "invalid", "aria-describedby"]),
          a.postalCode ? (k(), C("small", {
            key: 0,
            id: g,
            class: "card-field__error",
            "data-testid": "register__payment-postal-error"
          }, Y(a.postalCode), 1)) : D("", !0)
        ])) : D("", !0),
        u.value ? (k(), oe(N(rt), {
          key: 1,
          severity: "error",
          closable: !1,
          "data-testid": "register__payment-decline"
        }, {
          default: Ee(() => [
            tt(Y(u.value), 1)
          ]),
          _: 1
        })) : D("", !0),
        !G.value && !e.autoEmit ? (k(), oe(N(Ce), {
          key: 2,
          label: d.value ? "Saving card…" : "Save card",
          size: "small",
          disabled: te.value,
          loading: d.value,
          "data-testid": "register__payment-save",
          onClick: Te
        }, null, 8, ["label", "disabled", "loading"])) : D("", !0),
        G.value ? D("", !0) : (k(), C("small", Da, " Card details are handled directly by Neon Pay's secure fields. They never touch this site. "))
      ], 64)) : (k(), C(_t, { key: 2 }, [
        V("div", Ba, [
          L[1] || (L[1] = V("label", {
            for: "reg-card-number",
            class: "card-field__label"
          }, "Card number", -1)),
          V("div", Fa, [
            he(N(xe), {
              id: "reg-card-number",
              "model-value": i.number,
              autocomplete: "cc-number",
              inputmode: "numeric",
              maxlength: "23",
              fluid: "",
              size: e.size === "large" ? "large" : void 0,
              disabled: o.disabled || d.value,
              invalid: a.number !== null || o.invalid,
              "data-testid": "register__payment-number",
              placeholder: "1234 1234 1234 1234",
              "onUpdate:modelValue": ue,
              onBlur: it
            }, null, 8, ["model-value", "size", "disabled", "invalid"]),
            H.value !== "unknown" ? (k(), C("span", {
              key: 0,
              class: "card-field__brand",
              "data-brand": H.value,
              "data-testid": "register__payment-brand"
            }, Y(N(At)(H.value)), 9, Ma)) : D("", !0)
          ]),
          a.number ? (k(), C("small", Ua, Y(a.number), 1)) : D("", !0)
        ]),
        V("div", Ra, [
          V("div", Ka, [
            L[2] || (L[2] = V("label", {
              for: "reg-card-exp",
              class: "card-field__label"
            }, "Expires", -1)),
            he(N(xe), {
              id: "reg-card-exp",
              "model-value": i.exp,
              autocomplete: "cc-exp",
              inputmode: "numeric",
              maxlength: "5",
              placeholder: "MM/YY",
              fluid: "",
              size: e.size === "large" ? "large" : void 0,
              disabled: o.disabled || d.value,
              invalid: a.exp !== null,
              "data-testid": "register__payment-exp",
              "onUpdate:modelValue": we,
              onBlur: lt
            }, null, 8, ["model-value", "size", "disabled", "invalid"]),
            a.exp ? (k(), C("small", Wa, Y(a.exp), 1)) : D("", !0)
          ]),
          V("div", Ha, [
            L[3] || (L[3] = V("label", {
              for: "reg-card-cvc",
              class: "card-field__label"
            }, "CVC", -1)),
            he(N(xe), {
              id: "reg-card-cvc",
              "model-value": i.cvc,
              autocomplete: "cc-csc",
              inputmode: "numeric",
              maxlength: "4",
              placeholder: "123",
              fluid: "",
              size: e.size === "large" ? "large" : void 0,
              disabled: o.disabled || d.value,
              invalid: a.cvc !== null,
              "data-testid": "register__payment-cvc",
              "onUpdate:modelValue": me,
              onBlur: st
            }, null, 8, ["model-value", "size", "disabled", "invalid"]),
            a.cvc ? (k(), C("small", Ya, Y(a.cvc), 1)) : D("", !0)
          ])
        ]),
        V("div", Ga, [
          L[4] || (L[4] = V("label", {
            for: "reg-card-postal",
            class: "card-field__label"
          }, "Postal code", -1)),
          he(N(xe), {
            id: "reg-card-postal",
            "model-value": i.postalCode,
            autocomplete: "postal-code",
            maxlength: "10",
            fluid: "",
            size: e.size === "large" ? "large" : void 0,
            disabled: o.disabled || d.value,
            invalid: a.postalCode !== null,
            "data-testid": "register__payment-postal",
            "onUpdate:modelValue": Oe,
            onBlur: dt
          }, null, 8, ["model-value", "size", "disabled", "invalid"]),
          a.postalCode ? (k(), C("small", Za, Y(a.postalCode), 1)) : D("", !0)
        ]),
        u.value ? (k(), oe(N(rt), {
          key: 0,
          severity: "error",
          closable: !1,
          "data-testid": "register__payment-decline"
        }, {
          default: Ee(() => [
            tt(Y(u.value), 1)
          ]),
          _: 1
        })) : D("", !0),
        e.autoEmit ? D("", !0) : (k(), oe(N(Ce), {
          key: 1,
          label: d.value ? "Saving card…" : "Save card",
          size: "small",
          disabled: te.value,
          loading: d.value,
          "data-testid": "register__payment-save",
          onClick: Te
        }, null, 8, ["label", "disabled", "loading"])),
        L[5] || (L[5] = V("small", { class: "card-field__helper" }, " Your card is stored securely by Neon Pay. We don't keep the full number. ", -1))
      ], 64))
    ], 2));
  }
}), In = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, si = /* @__PURE__ */ In(qa, [["__scopeId", "data-v-496ef5c8"]]), Xa = {
  key: 0,
  class: "bank-field__saved",
  "data-testid": "bank-field__saved"
}, Qa = { class: "bank-field__last4" }, Ja = {
  key: 1,
  class: "bank-field__helper",
  "data-testid": "bank-field__no-provider"
}, ei = {
  key: 0,
  class: "bank-field__helper",
  "data-testid": "bank-field__unavailable"
}, ti = {
  key: 1,
  class: "bank-field__helper",
  "data-testid": "bank-field__loading"
}, ni = {
  key: 2,
  class: "bank-field__error",
  "data-testid": "bank-field__sdk-error"
}, oi = {
  key: 5,
  class: "bank-field__helper"
}, ri = 2e4, ai = /* @__PURE__ */ mn({
  __name: "NeonPayBankAccountField",
  props: {
    modelValue: {},
    provider: { default: null },
    processor: { default: null },
    gateway: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    billing: {},
    customizeFields: {},
    size: { default: "default" },
    showSave: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "error", "bank-saved"],
  setup(e, { expose: t, emit: n }) {
    const o = e, r = n, l = U(() => (o.processor ?? "").toLowerCase().includes("stripe")), s = `np-bank-mount-${et()}`, i = M(null), a = M(!1), d = M(null), u = M(!1), c = M(null), p = M(null), m = M(!1);
    let b = null;
    const v = U(() => ({
      ...o.billing ?? {},
      // ACH requires country at tokenization. Placed after the spread so a caller
      // cannot accidentally drop it.
      country: "US",
      reuse: !0
    })), g = U(
      () => o.customizeFields ? { customizeFields: o.customizeFields } : {}
    ), $ = U(() => Jn(o.provider, "ach")), {
      ready: S,
      initialized: O,
      canMakePayment: f,
      error: y,
      init: _,
      createToken: x,
      unmount: A,
      on: K
    } = vn({
      publicKey: U(() => $.value?.publicKey ?? ""),
      merchantId: U(() => $.value?.merchantId ?? ""),
      sandbox: U(() => $.value?.sandbox),
      gateway: U(() => o.gateway),
      container: i,
      fieldType: "bankaccount",
      fieldOptions: g,
      tokenData: v
    });
    K("achAuthorized", () => {
      m.value = !0, b?.(), b = null;
    }), K("change", (T) => {
      const F = T ?? {};
      if (F.error?.code === Xn) {
        u.value = !0;
        return;
      }
      (F.complete || F.empty) && (d.value = null);
    });
    const W = U(
      () => u.value || O.value && !f.value && !y.value
    ), B = U(() => !!o.modelValue && c.value !== null);
    be(
      i,
      async (T) => {
        !T || !o.provider || (await _(), y.value && r("error", y.value));
      },
      { immediate: !0 }
    );
    function G() {
      return m.value ? Promise.resolve(!0) : new Promise((T) => {
        const F = setTimeout(() => {
          b = null, T(!1);
        }, ri);
        b = () => {
          clearTimeout(F), T(!0);
        };
      });
    }
    function X(T) {
      d.value = T, r("error", T), r("update:modelValue", ""), c.value = null, p.value = null;
    }
    async function Q() {
      if (!(!o.provider || W.value || a.value)) {
        d.value = null, a.value = !0;
        try {
          if (!m.value && l.value && !await G()) {
            X("Confirm your bank details to finish adding this account, then try again.");
            return;
          }
          const T = await x();
          if (T.status === "decline") {
            X(T.message);
            return;
          }
          p.value = T.brand === "unknown" ? null : T.brand, c.value = T.last4, r("update:modelValue", T.token), r("bank-saved", {
            token: T.token,
            bankName: p.value,
            last4: c.value
          });
        } catch (T) {
          X(T instanceof Error ? T.message : "Something went wrong. Try again.");
        } finally {
          a.value = !1;
        }
      }
    }
    be(m, async (T) => {
      T && l.value && !o.modelValue && await Q();
    });
    function Z() {
      A(), m.value = !1, b = null, c.value = null, p.value = null, d.value = null, r("update:modelValue", ""), _();
    }
    return t({ tokenize: Q, reset: Z }), (T, F) => (k(), C("div", {
      class: ke(["bank-field", { "bank-field--large": e.size === "large" }]),
      "data-testid": "bank-field"
    }, [
      B.value ? (k(), C("div", Xa, [
        F[0] || (F[0] = V("span", { class: "bank-field__badge" }, "BANK", -1)),
        V("span", Qa, Y(p.value ? `${p.value} ` : "") + "•••• " + Y(c.value), 1),
        he(N(Ce), {
          link: "",
          size: "small",
          label: "Change",
          disabled: o.disabled,
          "data-testid": "bank-field__change",
          onClick: Z
        }, null, 8, ["disabled"])
      ])) : o.provider ? (k(), C(_t, { key: 2 }, [
        at(V("div", {
          id: s,
          ref_key: "mountEl",
          ref: i,
          class: ke(["bank-field__mount", { "bank-field__mount--invalid": o.invalid, "bank-field__mount--disabled": o.disabled }]),
          "data-testid": "bank-field__mount"
        }, null, 2), [
          [fn, !W.value]
        ]),
        W.value ? (k(), C("small", ei, " Bank transfers aren't available for this auction right now. Use a card instead, or contact the organizer. ")) : !N(S) && !N(y) ? (k(), C("small", ti, " Loading secure bank fields… ")) : N(y) ? (k(), C("small", ni, Y(N(y)), 1)) : D("", !0),
        d.value ? (k(), oe(N(rt), {
          key: 3,
          severity: "error",
          closable: !1,
          "data-testid": "bank-field__decline"
        }, {
          default: Ee(() => [
            tt(Y(d.value), 1)
          ]),
          _: 1
        })) : D("", !0),
        o.showSave && !W.value && !N(y) ? (k(), oe(N(Ce), {
          key: 4,
          label: a.value ? "Saving bank account…" : "Save bank account",
          size: "small",
          disabled: o.disabled || a.value || !N(S),
          loading: a.value,
          "data-testid": "bank-field__save",
          onClick: Q
        }, null, 8, ["label", "disabled", "loading"])) : D("", !0),
        W.value ? D("", !0) : (k(), C("small", oi, " Bank details are handled directly by Neon Pay. They never touch this site. Bank transfers take a few business days to clear. "))
      ], 64)) : (k(), C("small", Ja, " Bank transfers aren't available for this auction. "))
    ], 2));
  }
}), di = /* @__PURE__ */ In(ai, [["__scopeId", "data-v-5e6eaa51"]]);
export {
  di as NeonPayBankAccountField,
  si as NeonPayCardField,
  Xn as UNSUPPORTED_PAYMENT_METHOD_CODE,
  At as brandLabel,
  Ot as detectBrand,
  ao as formatCardNumber,
  io as formatExpiry,
  li as isCardExpired,
  Qn as loadNeonPayScript,
  mt as luhnValid,
  Jn as providerForSlot,
  lo as tokenizeCard,
  vn as useNeonPay,
  bt as validCvc,
  ft as validExpiry,
  gt as validPostalCode
};
//# sourceMappingURL=index.js.map
